// 公共与导航：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 公共基础词条
export const base = Object.freeze({
  "chatWorkbench.inboxChannels": "聯絡人分組",
  "chatWorkbench.personalContacts": "真人",
  "chatWorkbench.receptionContacts": "客服",
  "chatWorkbench.selfChat": "和自己聊天",
  "chatWorkbench.selfChatHint": "記錄想法、備忘和待辦",
  "chatWorkbench.pinConversation": "置頂",
  "chatWorkbench.unpinConversation": "取消置頂",
  "chatWorkbench.pinnedConversation": "已置頂",
  "chatWorkbench.conversationMenuHint": "右鍵或長按開啟會話選單，鍵盤可按Shift+F10",
  "chatWorkbench.back": "返回",
  "chatWorkbench.expandSheet": "展開聊天",
  "chatWorkbench.restoreSheet": "還原半窗",
  "chatWorkbench.agent.general": "客服 Agent",
  "chatWorkbench.agent.product": "商品 Agent",
  "chatWorkbench.agent.order": "訂單諮詢",
  "chatWorkbench.agent.supply_demand": "供需 Agent",
  "chatWorkbench.resizeSheet": "調整聊天視窗大小，目前{percent}%",
  "chatWorkbench.resizeSheetHint": "拖動頂部白條調整高度；點擊依次切換80%、100%、80%、50%。亦可使用上下方向鍵調整。",
  "clueDatasheet.notFound": "未找到該料號的規格書",
  "clueDatasheet.ambiguous": "該料號有多個品牌，請確認品牌後重試",
  "clueDatasheet.failed": "規格書載入失敗，請稍後重試",

  "chatWorkbench.title": "訊息工作台",
  "chatWorkbench.pin": "固定視窗，切頁保持展開",
  "chatWorkbench.unpin": "取消固定，切頁自動收納",
  "chatWorkbench.conversations": "會話",
  "chatWorkbench.hideConversations": "收起會話列表",

  "workflowChatAgent.title": "唯讀群聊助手",
  "workflowChatAgent.progress": "查詢進度",
  "workflowChatAgent.summary": "總結討論",
  "workflowChatAgent.issues": "歸納問題",
  "workflowChatAgent.cancel": "取消任務",
  "workflowChatAgent.rangeHint": "基於本輪最近200條以內的訊息與當前業務快照。",
  "workflowChatAgent.failedHint": "本次任務未完成，可重新發起查詢。",
  "workflowChatAgent.unavailable": "智能助手暫不可用，請稍後重試。",
  "workflowChatAgent.messageEvidence": "訊息依據",
  "workflowChatAgent.businessEvidence": "業務快照依據",
  "workflowChatAgent.evidenceMissing": "該依據暫不可用",
  "workflowChatAgent.status.READY": "排隊中",
  "workflowChatAgent.status.RUNNING": "處理中",
  "workflowChatAgent.status.WAITING_RETRY": "等待重試",
  "workflowChatAgent.status.SUCCEEDED": "已完成",
  "workflowChatAgent.status.FAILED": "未完成",
  "workflowChatAgent.status.CANCELLED": "已取消",
  "workflowChatAgent.status.DEAD_LETTER": "重試已結束",
  "devUpdates.googleContinue": "使用 Google 帳戶繼續",
  "nav.brands": "品牌",
  "common.language": "語言",
  "common.chinese": "簡體中文",
  "common.english": "English",
  "common.login": "登入",
  "common.register": "註冊",
  "common.logout": "退出",
  "common.agentService": "客服",
  "common.wechat": "微信",
  "common.backToTop": "回到頂部",
  "common.loading": "載入中...",
  "common.loginRequired": "請先登入",
  "common.downloadFailed": "下載檔案失敗",
  "common.unauthorizedGoods": "商品庫介面未授權",
  "common.serverError": "伺服器錯誤",
  "common.operationFailed": "操作失敗",
  "common.requestError": "請求錯誤，請重試",
  "common.requestTimeout": "請求超時，請檢查網絡連接",
  "common.searchPlaceholder": "搜索料號、名稱",
  "common.searchAction": "先搜一下",
  "nav.home": "首頁",
  "nav.publish": "發佈",
  "nav.featured": "精選",
  "nav.bidding": "競標",
  "nav.supply": "供需",
  "nav.wiki": "百科",
  "nav.trade": "交易",
  "nav.ai": "先搜AI",
  "nav.mine": "我的",
  "nav.selfOperated": "自營",
  "nav.news": "資訊",
  "nav.priceChannel": "行情",
  "nav.bulkPublish": "大宗資料",
  "nav.featuredPublish": "精選商品",
  "nav.mobileBulkPublish": "大宗發佈",
  "nav.mobileFeaturedPublish": "精選發佈",
  "nav.quickNavigation": "首頁快捷導航",
});

// 固定字段显示
// 本次 dev 合并新增的固定显示提示。
export const merged20261021 = Object.freeze({
  "devUpdates.oct23BulkPublish": "大宗商品發佈",
  "devUpdates.oct23GoogleSignUp": "Google 註冊",
  "devUpdates.oct23GoogleSignIn": "Google 登入",
  "devUpdates.oct23ShippingRemarkRequired": "如不上載檔案，請填寫發貨備註",
  "devUpdates.oct23BuyerCommission": "買家佣金",
  "devUpdates.oct23PaymentDetails": "付款詳情",
  "devUpdates.oct23PaymentAmount": "付款金額",
  "devUpdates.oct23CreditRepayment": "信貸還款",
  "devUpdates.oct23CreditLimit": "信貸額度",
  "devUpdates.oct23LinkedBusinessNumber": "關聯業務單號",
  "devUpdates.oct23SellerSourcePrice": "賣方貨源價格",
  "devUpdates.oct23PriceHistory": "歷史價格資料",
  "devUpdates.oct23PreviousPrice": "原價",
  "devUpdates.oct23PreviousQuantity": "原數量",
  "devUpdates.oct23Repay": "還款",
  "devUpdates.oct23ShippingProofUploaded": "發貨憑證上載成功",
  "devUpdates.oct23ShippingProofFile": "發貨憑證檔案",
  "devUpdates.oct23ShippingRemark": "發貨備註",
  "devUpdates.oct23ShipmentDetails": "發貨詳情",
  "devUpdates.oct23ChangedAmount": "變動金額",
  "devUpdates.oct23Agree": "同意",
  "devUpdates.oct23No": "否",
  "devUpdates.oct23ClaimedGoodsEditHint":
    "商品已有談判人接單，請聯絡談判人修改",
  "devUpdates.oct23ProductTotal": "商品總價",
  "devUpdates.oct23ProductTotalPrefix": "商品總金額：",
  "devUpdates.oct23SplitProduct": "商品拆單",
  "devUpdates.oct23SettleProduct": "商品結單",
  "devUpdates.oct23RecipientForm": "填寫收貨資料",
  "devUpdates.oct23RemarkDescription": "備註說明",
  "devUpdates.oct23ReviewDecision": "審核結果",
  "devUpdates.oct23ReviewHistory": "審核記錄",
  "devUpdates.oct23WithdrawnAmount": "已提款金額",
  "devUpdates.oct23ConfirmedPurchaseIntention": "已確認購買意向單",
  "devUpdates.oct23PlatformPassword": "平台登入密碼",
  "devUpdates.oct23TotalPayable": "應付總額",
  "devUpdates.oct23Bank": "開戶銀行",
  "devUpdates.oct23BankName": "開戶銀行名稱",
  "devUpdates.oct23AvailableWithdrawalBalance": "目前可提款結餘",
  "devUpdates.oct23BuyerRevisionPending": "待買家修改購買意向單",
  "devUpdates.oct23IntentionRevisionPending": "待修改購買意向單",
  "devUpdates.oct23IntentionConfirmationPending": "待確認購買意向單",
  "devUpdates.oct23SellerIntentionPending": "待貨主確認購買意向單",
  "devUpdates.oct23CreditOutstanding": "待還信貸金額",
  "devUpdates.oct23OptionalWechat": "微信號碼（選填）",
  "devUpdates.oct23SplitQuantity": "拆單數量",
  "devUpdates.oct23Claim": "接單",
  "devUpdates.oct23Claimed": "接單成功",
  "devUpdates.oct23IdentityPhotoHint": "提交本人有效身份證明文件照片",
  "devUpdates.oct23SubmitIntentionPrice": "提交購買意向單價格",
  "devUpdates.oct23WithdrawalReview": "提款審核",
  "devUpdates.oct23WithdrawalHistory": "提款明細",
  "devUpdates.oct23WithdrawalReference": "提款流水號",
  "devUpdates.oct23WithdrawalStatus": "提款狀態",
  "devUpdates.oct23WithdrawalSubmitted": "提款申請已提交",
  "devUpdates.oct23WithdrawalIdProofRequired":
    "提款記錄缺少ID，無法提交付款憑證",
  "devUpdates.oct23WithdrawalIdReviewRequired": "提款記錄缺少ID，無法提交審核",
  "devUpdates.oct23WithdrawalIdReceiptRequired": "提款記錄缺少ID，無法確認收款",
  "devUpdates.oct23WithdrawalDetails": "提款詳情",
  "devUpdates.oct23WithdrawalAmount": "提款金額",
  "devUpdates.oct23ExpenseHistory": "支出明細",
  "devUpdates.oct23ExpenseDetails": "支出明細詳情",
  "devUpdates.oct23PayeeName": "收款人姓名",
  "devUpdates.oct23WholeOrderHint": "整單提交，毋須選擇規格",
  "devUpdates.oct23Yes": "是",
  "devUpdates.oct23WholeOrder": "是否整單",
  "devUpdates.oct23NoProofOrRemark": "暫無上載憑證或備註",
  "devUpdates.oct23NoChildProducts": "暫無子商品資料",
  "devUpdates.oct23NoReviewHistory": "暫無審核記錄",
  "devUpdates.oct23NoSpecifications": "暫無規格資料",
  "devUpdates.oct23RecentWithdrawals": "最近五筆提款申請及處理進度",
  "devUpdates.oct23SettlementHint": "檢視關聯訂單並填寫本次結單金額",
  "devUpdates.oct23Reference": "流水號",
  "devUpdates.oct23OverseasDocumentHint":
    "海外用戶可使用護照或當地政府簽發的身份證明文件",
  "devUpdates.oct23CurrentPrice": "現價",
  "devUpdates.oct23ContractPrice": "生成合約價格",
  "devUpdates.oct23RequestWithdrawal": "申請提款",
  "devUpdates.oct23SupervisorInspector": "監督人及驗貨人",
  "devUpdates.oct23ConfirmClaim": "確定接單",
  "devUpdates.oct23ConfirmIntentionPrice": "確認意向單價格",
  "devUpdates.oct23ReceiptConfirmed": "確認收款成功",
  "devUpdates.oct23ConfirmRepayment": "確認還款",
  "devUpdates.oct23Settle": "結單",
  "devUpdates.oct23Settled": "結單成功",
  "devUpdates.oct23SettlementAmount": "結單金額",
  "devUpdates.oct23SettlementExceedsTotal": "結單金額不能超過商品總金額",
  "devUpdates.oct23ProductIdRequired": "缺少商品ID，無法查詢關聯訂單",
  "devUpdates.oct23VerificationRegion": "認證地區",
  "devUpdates.oct23SplitWholeOrderUnavailable": "此商品已拆分，不可整單提交",
  "devUpdates.oct23GoogleBindingHint":
    "此電郵已有平台帳戶，請輸入原平台登入密碼以綁定Google。",
  "devUpdates.oct23ShippingProofOrRemarkRequired":
    "請上載發貨憑證檔案或填寫發貨備註",
  "devUpdates.oct23IdentityPhotoRequired": "請上載證件照片",
  "devUpdates.oct23IdentityBackRequired": "請上載身份證國徽面",
  "devUpdates.oct23PurchaseOrderRequired": "請先完成採購訂單",
  "devUpdates.oct23ConfirmWithdrawalReceipt":
    "請確認提款款項已到帳，確認後狀態將更新為已到帳。",
  "devUpdates.oct23ContactNegotiator": "請聯絡談判人修改",
  "devUpdates.oct23EnterSwiftCode": "請輸入Swift Code",
  "devUpdates.oct23EnterBuyerMobile": "請輸入買家手機號碼",
  "devUpdates.oct23EnterProductTotal": "請輸入商品總金額",
  "devUpdates.oct23RepaymentMinimum": "請輸入大於100的還款金額",
  "devUpdates.oct23EnterBankName": "請輸入開戶銀行名稱",
  "devUpdates.oct23EnterWithdrawalAmount": "請輸入提款金額",
  "devUpdates.oct23EnterPayeeName": "請輸入收款人姓名",
  "devUpdates.oct23EnterRecipientAddress": "請輸入收貨地址",
  "devUpdates.oct23EnterRecipientPhone": "請輸入收貨電話",
  "devUpdates.oct23EnterOwnMobile": "請輸入本人常用手機號碼",
  "devUpdates.oct23EnterOwnEmail": "請輸入本人常用電郵",
  "devUpdates.oct23InvalidSettlement": "請輸入正確的結單金額",
  "devUpdates.oct23EnterCurrentPrice": "請輸入現價",
  "devUpdates.oct23EnterSettlement": "請輸入結單金額",
  "devUpdates.oct23BalanceHistoryHint": "帳戶結餘變動及資金流向記錄",
  "devUpdates.oct23SellerCommission": "貨主佣金",
  "devUpdates.oct23FundDirection": "資金方向",
  "devUpdates.oct23FollowDetails": "跟單詳情",
  "devUpdates.oct23TransferProof": "轉帳憑證",
  "devUpdates.oct23Repaid": "還款成功",
  "devUpdates.oct23RepaymentAmount": "還款金額",
  "devUpdates.oct23SelectWithdrawalCurrency": "選擇提款貨幣",
  "devUpdates.oct23SelectSettlementUnit": "選擇結單金額單位",
  "devUpdates.oct23ReconnectGoogle": "重新連接Google",
  "devUpdates.oct23AmountType": "金額類型",
  "devUpdates.oct23VerifyExistingAccount": "驗證現有平台帳戶",
  "devUpdates.oct23VerifyAndSignIn": "驗證並登入",
  "devUpdates.oct23ProofFormatsHint":
    "（支援圖片、影片等檔案，檔案或備註至少填寫一項）",
  "devUpdates.oct23PurchaseOrderIncomplete": "（採購訂單尚未完成）",
  "devUpdates.oct23GoogleVerifying": "正在驗證Google帳戶…",
  "devUpdates.oct23GoogleConnecting": "正在連接Google…",
  "devUpdates.oct23GoogleVerifyingShort": "正在驗證Google帳戶",
  "devUpdates.oct23GoogleConnectingShort": "正在連接Google",
  "devUpdates.oct23GoogleConfigUnavailable": "Google登入設定暫時無法使用",
  "devUpdates.oct23GoogleInitializationFailed": "Google登入初始化失敗",
  "devUpdates.oct23GoogleLoginFailed": "Google登入失敗，請重試",
  "devUpdates.oct23ClaimFailed": "接單失敗",
  "devUpdates.oct23ClaimRetry": "接單失敗，請稍後重試",
  "devUpdates.oct23OwnMobile": "本人手機號碼",
  "devUpdates.oct23VerifyIdentityInstructions":
    "請驗證{method}並上載本人有效身份證明文件，確保填寫資料與證件一致。",
  "devUpdates.oct23IdentityVerificationCompletion":
    "{method}驗證通過後完成實名認證",
  "devUpdates.oct23DocumentPage": "證件資料頁",
  "devUpdates.oct23DocumentPageHint": "載有姓名、照片及證件號碼的一面",
  "devUpdates.oct23UploadDocumentPage": "上載證件資料頁",
  "devUpdates.oct23OptionalDocumentBack": "證件背面（選填）",
  "devUpdates.oct23DocumentBackHint": "如證件背面載有資料，請上載",
  "devUpdates.oct23UploadDocumentBack": "上載證件背面",
  "devUpdates.oct23DocumentNumber": "證件號碼",
  "devUpdates.oct23EnterOverseasDocument": "請輸入護照或當地身份證明文件號碼",
  "devUpdates.oct23EnterEmailCode": "請輸入4位電郵驗證碼",
  "devUpdates.oct23EmailCodeRequired": "請填寫4位電郵驗證碼",
  "devUpdates.oct23SmsCodeRequired": "請填寫4位短訊驗證碼",
  "devUpdates.oct23VerificationDocumentInvalid": "請輸入正確的證件號碼",
  "devUpdates.oct23MobileInvalid": "請填寫正確的手機號碼",
  "devUpdates.oct23EmailInvalid": "請填寫正確的電郵",
  "devUpdates.oct23BackOptional": "背面選填",
  "devUpdates.oct23EmailSent": "電郵已發送，請注意查收",
  "devUpdates.oct23SmsSent": "短訊已發送，請注意查收",
  "devUpdates.oct23WithdrawalUnderReview": "提款審核中",
  "devUpdates.oct23NormalAmount": "正常金額",
  "devUpdates.oct23UnknownBusiness": "未知業務",
  "devUpdates.oct23UnknownDirection": "未知方向",
  "devUpdates.oct23ProductSale": "商品出售",
  "devUpdates.oct23SelfDeposit": "自行增值",
  "devUpdates.oct23SystemGrant": "系統贈送",
  "devUpdates.oct23ProductPurchase": "購買商品",
  "devUpdates.oct23BalanceWithdrawal": "結餘提款",
  "devUpdates.oct23SelectReview": "請選擇審核結果",
  "devUpdates.oct23EnterRepayment": "請輸入還款金額",
  "devUpdates.oct23SelectWithdrawalCurrencyRequired": "請選擇提款貨幣",
  "devUpdates.oct23FileUploading": "檔案上載中",
  "devUpdates.shippingManagement": "發貨管理",
  "devUpdates.createdBankSelectionRequired":
    "銀行已建立，但未能識別新銀行，請按更換重新選擇",
  "shipping.title": "訂單發貨",
  "shipping.supplierIntro": "填寫訂單商品本批發貨數量及物流資料",
  "shipping.completed": "發貨完成",
  "shipping.intro": "選擇入倉號及出庫單，填寫本批數量及物流資料",
  "shipping.orderQuantity": "訂單數量",
  "shipping.sentQuantity": "已發數量",
  "shipping.remainingQuantity": "待發數量",
  "shipping.historicalWarning": "此訂單已有物流記錄，請核對原已發數量。",
  "shipping.batchTitle": "第{sequence}批發貨",
  "shipping.pending": "待發貨",
  "shipping.partial": "部分發貨",
  "shipping.complete": "全部發貨",
  "shipping.shipped": "已發貨",
  "shipping.deleteDraft": "刪除草稿",
  "shipping.addWarehouse": "新增入倉號",
  "shipping.deleteRow": "刪除此行",
  "shipping.warehouseNumber": "入倉號",
  "shipping.outboundOrder": "出庫單",
  "shipping.noMatches": "沒有符合的資料",
  "shipping.warehouseSearch": "請輸入入倉號搜尋",
  "shipping.outboundSearch": "請輸入出庫單搜尋",
  "shipping.sourceHint":
    "選擇入倉號或出庫單後會自動關聯另一欄；本次發貨預設填入可發數量，可修改，不發貨的商品請留空。",
  "shipping.sourceEmpty": "此入倉號及出庫單暫無商品明細。",
  "shipping.requestedQuantity": "申請出庫數量",
  "shipping.availableQuantity": "剩餘可發貨數量",
  "shipping.thisShipment": "本次發貨",
  "shipping.enterQuantity": "填寫數量",
  "shipping.reselectDraft": "請為原草稿重新選擇一組入倉號及出庫單後儲存。",
  "shipping.enterRecipient": "請輸入收貨人",
  "shipping.enterPhone": "請輸入聯絡電話",
  "shipping.enterAddress": "請輸入詳細收貨地址",
  "shipping.enterCompany": "請輸入物流公司",
  "shipping.enterTracking": "請輸入物流單號",
  "shipping.proofOrRemark": "發貨憑證／備註",
  "shipping.oneRequired": "至少填寫一項",
  "shipping.remarkPlaceholder": "填寫發貨說明，或在下方上載憑證",
  "shipping.uploadProof": "上載憑證",
  "shipping.proofFormats": "JPG、PNG、PDF，最多10個",
  "shipping.addBatch": "新增發貨（下一批）",
  "shipping.allShipped": "訂單商品已全部發貨",
  "shipping.submitLocks": "提交後，本批資料不可修改",
  "shipping.readOnly": "已發批次只供檢視",
  "shipping.submitBatch": "提交本批發貨",
  "shipping.queryUnavailable": "查詢服務無法使用，請核對接口地址或部署狀態",
  "shipping.queryFailed": "查詢失敗，請重新搜尋",
  "shipping.orderMissing": "缺少訂單編號，無法建立發貨記錄",
  "shipping.loadFailed": "載入發貨資料失敗",
  "shipping.submitCurrent": "請先提交目前批次，再新增下一批發貨",
  "shipping.sourceDuplicate": "此入倉號及出庫單已新增，請選擇其他組合",
  "shipping.sourceRequired": "請重新選擇一組入倉號及出庫單後儲存",
  "shipping.saveFailed": "發貨儲存失敗，請重試",
  "shipping.cleanupFailed": "發貨已儲存，但本機草稿清理失敗，請重新整理頁面",
  "shipping.saved": "本批發貨已儲存至伺服器，資料已鎖定",
  "shipping.draftSaved": "本機草稿已儲存",
  "shipping.deleteConfirmation": "確定刪除目前草稿？已發貨記錄不受影響。",
  "shipping.unsavedConfirmation": "目前批次有未儲存修改，是否儲存草稿後關閉？",
  "shipping.unsavedChanges": "未儲存的修改",
  "shipping.saveAndClose": "儲存並關閉",
  "shipping.discard": "放棄修改",
  "shipping.records": "分批發貨記錄",
  "shipping.loading": "發貨記錄載入中…",
  "shipping.historyFailed": "發貨記錄載入失敗",
  "shipping.goodsWarehouse": "商品入倉號",
  "shipping.sourceOutbound": "來源出庫單",
  "shipping.quantity": "發貨數量",
  "shipping.receiverInfo": "收貨資料：",
  "shipping.logisticsInfo": "物流資料：",
  "shipping.buyerCompany": "買方公司：",
  "shipping.warehousePrefix": "入倉號：",
  "shipping.orderPrefix": "訂單號：",
  "shipping.remarkPrefix": "備註：",
  "shipping.allocatedExceeded":
    "{name}本批合計 {quantity} {unit}，超過待發數量 {remaining}",
  "shipping.sold": "已售",
  "shipping.viewDatasheet": "查看規格書",
  "shipping.businessReview": "新增業務審批",
  "shipping.outboundReviewers": "出庫單審核人",
  "devUpdates.rejectInspectionsInBulk": "批量駁回",
  "devSync.priceMaxDecimals": "最多4位小數",
  "devSync.priceRequired": "請填寫價格或金額",
  "devSync.nonnegativePrice": "請填寫大於或等於0的數值",
  "devSync.searchWarehouseReceipt": "請輸入入倉編號搜尋",
  "devSync.noMatchingWarehouseReceipt": "暫無相符入倉編號",
  "devSync.warehouseReceiptSearchFailed": "查詢失敗，請重新輸入入倉編號再試",
  "devSync.receivedWarehouse": "入倉倉庫",
  "devSync.savedInspectionReloadFailed":
    "儲存成功，明細重新整理失敗，請重新整理頁面後繼續操作",
  "devSync.deleteReceiptDetailConfirmation":
    "刪除後該入倉明細及對應的驗貨細節將一併刪除，確定刪除嗎？",
});

export const formDisplay = Object.freeze({
  "devSync.usdCurrencyLabel": "$(美元)",
  "devSync.videos": "影片",
  "devSync.manufacturer": "產品廠商",
  "devSync.productParameters": "產品參數",
  "devSync.productDimensions": "產品尺寸",
  "devSync.productQuantityAndUnit": "產品數量和單位",
  "devSync.productNumber": "產品編號",
  "devSync.productCode": "產品編碼",
  "devSync.productWeight": "產品重量",
  "devSync.certificateOfOrigin": "產地證明",
  "devSync.conversationRenamed": "對話名稱已修改",
  "devSync.deep": "低沉",
  "devSync.multiplierSymbol": "倍",
  "devSync.questionsRemainingWithoutSigningIn": "免登入尚可提問",
  "devSync.receivedStock": "入倉庫存",
  "devSync.closeVoiceSettings": "關閉聲音設定",
  "devSync.dispatchWarehouse": "出庫倉庫",
  "devSync.dispatchOrderInformation": "出庫單資料",
  "devSync.dispatchOrderNumber": "出庫單號",
  "devSync.dispatchOrderReview": "出庫單審核",
  "devSync.dispatchOrderReviewer": "出庫單審核人",
  "devSync.dispatchQuantity": "出庫數量",
  "devSync.dispatchDate": "出庫日期",
  "devSync.dispatchDetails": "出庫明細",
  "devSync.dispatchAttachments": "出庫附件",
  "devSync.deleteReceiptAndInspectionDetails": "刪除入倉記錄及驗貨細節",
  "devSync.deleteAttachment": "刪除附件",
  "devSync.addedToCart": "已加入購物車",
  "devSync.semitones": "半音",
  "devSync.publicationType": "發佈類型",
  "devSync.priceCurrency": "商品價格貨幣單位",
  "devSync.imagesOrVideosAreUploadingPleaseWait":
    "圖片或影片正在上傳，請稍後操作",
  "devSync.failedToReadTheImage": "圖片讀取失敗",
  "devSync.loadingVoices": "聲音載入中…",
  "devSync.voiceSettings": "聲音設定",
  "devSync.bulkPublicationIsComingSoon": "大宗發佈功能正在準備中，敬請期待",
  "devSync.approvalNumber": "審批編號",
  "devSync.thisBrowserDoesNotSupportRecording": "目前瀏覽器不支援錄音",
  "devSync.thisBrowserDoesNotSupportPitchAdjustment":
    "目前瀏覽器不支援音高調節",
  "devSync.theCameraIsUnavailableInThisBrowserSwitchedToTheSystemCamera":
    "目前瀏覽器無法直接使用相機，已切換至系統拍照",
  "devSync.fast": "快",
  "devSync.restoreDefaults": "還原預設值",
  "devSync.slow": "慢",
  "devSync.department": "所屬部門",
  "devSync.holdTheVoiceButtonBelowToSpeak": "按住下方語音按鈕即可說話",
  "devSync.multipleFilesSupported": "支援上傳多個檔案",
  "devSync.filesAreUploadingPleaseWaitBeforeSwitchingProducts":
    "檔案正在上傳，請稍後切換商品",
  "devSync.createProductInformation": "新增產品資料",
  "devSync.microphonePermissionUnavailable": "無法取得咪高峰權限",
  "devSync.bright": "明亮",
  "devSync.noDispatchDetails": "暫無出庫明細",
  "devSync.noSpeechDetectedPleaseTryAgain": "未識別到語音內容，請重試",
  "devSync.keptDuringThisVisitSignInToSave": "本次瀏覽期間保留，登入後可儲存",
  "devSync.timesKeptDuringThisVisitSignInToSave":
    "次 · 本次瀏覽期間保留，登入後可儲存",
  "devSync.loadingInformation": "正在載入資料…",
  "devSync.addDetails": "新增明細",
  "devSync.clickOrDragFilesToUpload": "點擊或拖放上傳附件",
  "devSync.failedToCaptureAPhotoPleaseTryAgain": "照片產生失敗，請重新拍照",
  "devSync.signInToViewConversationHistory": "登入後查看對話紀錄",
  "devSync.theCameraIsNotReadyPleaseTryAgainLater":
    "相機尚未準備好，請稍後重試",
  "devSync.cameraPermissionUnavailableSwitchedToTheSystemCamera":
    "相機權限不可用，已切換至系統拍照",
  "devSync.chipType": "晶片類型",
  "devSync.thisReceiptIsSavedDeletingItAlsoDeletesItsInspectionDetailsContinue":
    "此入倉記錄已儲存，刪除後相關驗貨細節亦會刪除，確認刪除？",
  "devSync.speechSpeed": "語速",
  "devSync.voiceToolbar": "語音工具列",
  "devSync.enterThePrimaryContact": "請填寫主要聯絡人",
  "devSync.enterTheManufacturer": "請填寫廠商名稱",
  "devSync.enterTheDateCodeDc": "請填寫批次(DC)",
  "devSync.enterAtLeastOneValidReceivedQuantity":
    "請填寫至少一項有效的入倉數量",
  "devSync.searchByProductName": "請輸入產品名稱搜尋",
  "devSync.enterTheProductCode": "請輸入產品編碼",
  "devSync.enterReceivedStock": "請輸入入倉庫存",
  "devSync.enterTheDispatchOrderNumber": "請輸入出庫單號",
  "devSync.enterDispatchOrderNotes": "請輸入出庫單相關說明",
  "devSync.enterTheDispatchQuantity": "請輸入出庫數量",
  "devSync.enterAnAlternativeBrand": "請輸入替代品牌",
  "devSync.enterAnAlternativePartNumber": "請輸入替代料號",
  "devSync.selectAPdfFileOrImage": "請選擇 PDF 檔案或圖片",
  "devSync.selectAWarehouseReceiptNumber": "請選擇入倉號",
  "devSync.selectADispatchWarehouse": "請選擇出庫倉庫",
  "devSync.selectADispatchDate": "請選擇出庫日期",
  "devSync.informationIsTemporarilyUnavailable": "資料暫時無法載入",
  "devSync.carouselImage": "輪播圖片",
  "devSync.selectDispatchWarehouse": "選擇出庫倉庫",
  "devSync.selectDispatchDate": "選擇出庫日期",
  "devSync.selectAVoice": "選擇聲音",
  "devSync.linkOrId": "連結或ID",
  "devSync.attachmentsAndNotes": "附件及備註",
  "devSync.pitch": "音高",
  "devSync.rejectSalesOrder": "退回銷售單",
  "devSync.verificationIsNotIntegratedYetEnterAnyFourDigits":
    "驗證碼暫未接入，請先填寫任意4位數字",
  "devSync.recipient": "收貨人",
  "devSync.recipientPhone": "收貨電話",
  "devSync.loginFailedCheckYourAccountDetails": "登入失敗，請檢查帳戶資料",
  "devSync.turnOffAutomaticSpeech": "關閉自動播放語音",
  "devSync.turnOnAutomaticSpeech": "開始自動播放語音",
  "devSync.readReplyAloud": "朗讀回覆",
  "devSync.playGeneratedSpeech": "播放已產生的語音",
  "devSync.generatingSpeechClickToCancel": "正在產生語音，點擊取消",
  "devSync.stopReadingAloud": "停止朗讀",
  "devSync.awaitingSupervisorConfirmation": "待監督人確認",
  "devSync.notLoaded": "未載入",
  "devSync.noMatchingProducts": "暫無符合商品",
  "devSync.searchFailedEnterYourQueryAgain": "搜尋失敗，請重新輸入並重試",
  "devSync.retrievedFilesDocumentsSnippetsSnippets":
    "檢索到 {files} 份資料 · {snippets} 個片段",
  "devSync.failedToLoadVoicesPleaseTryAgain": "聲音清單載入失敗，請重試",
  "devSync.failedToGenerateSpeechPleaseTryAgain": "語音產生失敗，請重試",
  "devSync.snippetWarning":
    "只有相關片段送入模型上下文，檢索命中不代表最終引用",
  "devSync.candidateWarning": "候選資料已送入模型上下文，不代表最終引用",
});

// 目录固定标签
export const catalogDisplay = Object.freeze({
  "devOct15.aiLoading": "先搜AI載入中…",
  "devOct15.conversationToolbar": "對話主題及語音工具列",
  "devOct15.aiConnecting": "正在連接 AI 助手…",
  "devOct15.moreSeller": "更多賣家資料",
  "devOct15.standardDisclaimer":
    "參數來源：題庫標準答案。說明內容由 AI 按參數產生，待確認；通用建議不代表該型號規格書的結論。",
  "devOct15.viewWiki": "查看百科資料",
  "devOct15.modules": "記憶體模組",
  "devOct15.controllers": "記憶體介面／控制器",
  "devOct15.nonvolatile": "非揮發性記憶體",
  "devOct15.otherMemory": "其他記憶體",
});

// 系统反馈
export const systemFeedback = Object.freeze({
  "devUpdates.startAConversationWithName": "開始與{name}的對話",
  "devUpdates.sending": "發送中...",
  "devUpdates.failedToSend": "發送失敗",
  "devUpdates.typeAMessage": "輸入訊息...",
  "devUpdates.loadingProducts": "正在載入產品…",
  "devUpdates.businessLicenseValidity": "營業執照有效期",
  "devUpdates.saving": "儲存中...",
  "devUpdates.collapseInput": "收起輸入框",
  "devUpdates.expandInput": "展開輸入框",
  "devUpdates.cameraPreview": "相機取景",
  "devUpdates.confirmCapturedPhoto": "確認拍攝照片",
  "devUpdates.recognizeAPhoto": "拍照識別",
  "devUpdates.confirmPhoto": "確認照片",
  "devUpdates.releaseToCancel": "鬆手取消",
  "devUpdates.releaseToSendSlideUpToCancel": "鬆手發送，上移取消",
  "devUpdates.linked": "已綁定",
  "devUpdates.notLinked": "待綁定",
  "devUpdates.hideSellerInformation": "收起賣方資料",
  "devUpdates.moreSellerInformation": "查看更多賣方資料",
  "devUpdates.hideBuyerInformation": "收起買方資料",
  "devUpdates.moreBuyerInformation": "查看更多買方資料",
  "devUpdates.orderReviewer": "訂單審核人",
  "devUpdates.contractReviewer": "合同審核人",
  "devUpdates.supplierAttachments": "供應商附件",
  "devUpdates.hideSalesOrderInformation": "收起銷售訂單資料",
  "devUpdates.hidePurchaseOrderInformation": "收起採購訂單資料",
  "devUpdates.morePurchaseOrderInformation": "更多采購訂單資料",
  "devUpdates.hideAdditionalInformation": "收起更多資料",
  "devUpdates.showAdditionalInformation": "展開更多資料",
  "devUpdates.noTaxId": "暫無税號",
  "devUpdates.productNotSpecified": "未填寫產品",
  "devUpdates.noPersonInCharge": "暫無負責人",
  "devUpdates.asAgreed": "按商定",
  "devUpdates.seller": "貨主：",
  "devUpdates.orderTotalExceeded": "訂單總額超出",
  "devUpdates.orderTotalUnpaid": "訂單總額未支付",
  "devUpdates.hongKongAccount": "香港賬戶",
  "devUpdates.mainlandChinaAccount": "境內賬戶",
  "devUpdates.secondsBeforeResending": "秒後重新發送",
  "devUpdates.noApprovalNotes": "暫無審批備註",
  "devUpdates.previouslyTraded": "交易過",
  "devUpdates.noPreviousTrades": "未交易",
  "devUpdates.ordinalPrefix": "第",
  "devUpdates.installment": "期",
  "devUpdates.searchReviewers": "搜索審核人",
  "devUpdates.reviewer": "審核人",
  "devUpdates.uploadThisInstallmentsPaymentReceipt": "上傳本期支付憑證",
  "devUpdates.confirmed": "（已確認）",
  "devUpdates.unconfirmed": "（未確認）",
  "devUpdates.uploadPaymentMethodAttachments": "付款方式附件上傳",
  "devUpdates.bidClosingReview": "截標審核",
  "devUpdates.publicationInformation": "發佈資料",
  "devUpdates.bidClosingInformation": "截標資料",
  "devUpdates.singlePublication": "單條發佈",
  "devUpdates.biddingReviewDetails": "競標審核明細",
  "devUpdates.bidClosingReviewDetails": "截標審核明細",
  "devUpdates.saveInspectionRecord": "儲存驗貨記錄",
  "devUpdates.inspectionReview": "驗貨審核",
  "devUpdates.confirmInspectionsInBulk": "批量確認驗貨",
  "devUpdates.confirmInspection": "確認驗貨",
  "devUpdates.uploadedDocuments": "已上傳資料",
  "devUpdates.generatingWikiContent": "正在生成百科內容...",
  "devUpdates.aiWikiQA": "AI 百科問答",
  "devUpdates.wikiQA": "百科問答",
  "devUpdates.qAEntries": "條問答",
  "devUpdates.discussions": "個討論",
  "devUpdates.generatingQAFromWikiSections": "正在根據百科欄目生成問答…",
  "devUpdates.basedOnSpecificationsTechnicalFeaturesApplicationsAndPrecautions":
    "依據規格説明、技術特點、應用領域和使用注意事項",
  "devUpdates.noDiscussionsForThisProductPopularQAIsShownInstead":
    "暫未找到該產品討論，正在展示熱門問答",
  "devUpdates.currentProductDiscussions": "當前產品討論",
  "devUpdates.reviewPaymentReceipt": "審核付款憑證",
  "devUpdates.reviewPaymentMethod": "審核付款方式",
  "devUpdates.selectPaymentMethod": "選擇付款方式",
  "devUpdates.paymentReceiptReviewer": "付款憑證審核人",
  "devUpdates.paymentMethodReviewer": "付款方式審核人",
  "devUpdates.onlyJpgPngGifAndBmpImagesAreSupported":
    "只支持jpg、png、gif、bmp格式的圖片",
  "devUpdates.imagesMustNotExceed10Mb": "圖片大小不能超過10M",
  "devUpdates.onlyImagesAreSupported": "只支持圖片",
  "devUpdates.imageSizeLimit": "圖片不能超過10M",
  "devUpdates.selectAnImageOrEnterTextFirst": "請先選擇圖片或輸入文字資料",
  "devUpdates.requestFailed": "介面請求失敗",
  "devUpdates.theImagePickerIsNotReady": "圖片選擇組件未載入",
  "devUpdates.onlyPdfPngAndJpgFilesAreSupported":
    "只支持pdf、png、jpg格式的檔案",
  "devUpdates.filesMustNotExceed10Mb": "檔案大小不能超過10M",
  "devUpdates.onlyPngAndJpgImagesAreSupported": "只支持png、jpg格式的圖片",
  "devUpdates.recognitionSucceeded": "識別成功 ✅",
  "devUpdates.copied": "已複製",
  "devUpdates.productLinkedSuccessfully": "綁定商品成功!",
  "devUpdates.thisPageSupportsPurchaseOrderAndPurchaseContractReviewOnly":
    "當前頁面僅支持採購訂單審核和採購合同審批",
  "devUpdates.failedToLoadApprovalStatus": "獲取審批節點狀態失敗",
  "devUpdates.uploadTheContractFileFirst": "請先上傳合同檔案",
  "devUpdates.theContractFileIsUnchangedNoUploadIsNeeded":
    "合同檔案未發生變更，無需上傳",
  "devUpdates.relatedContentUpdated": "關聯內容已更新",
  "devUpdates.removedSuccessfully": "移除成功",
  "devUpdates.contractApprovalRequested": "發起合同審批成功",
  "devUpdates.enterTheRejectionReason": "請填寫駁回理由",
  "devUpdates.unsupportedDownloadResponse": "無法識別的下載響應類型",
  "devUpdates.fileDownloaded": "檔案下載完成",
  "devUpdates.downloadFailedTheServerReturnedAnError":
    "下載失敗，伺服器返回了錯誤",
  "devUpdates.paymentApproved": "付款審核成功",
  "devUpdates.paymentRequestRejected": "付款申請已駁回",
  "devUpdates.contractIdIsMissing": "缺少合同ID參數",
  "devUpdates.failedToLoadContractData": "載入合同數據失敗",
  "devUpdates.theCustomerUploadedASingleStampedContractThisOptionCannotBeChanged":
    "客戶已上傳單章合同檔案，不能再切換該選項",
  "devUpdates.chooseEitherAContractTemplateOrASingleStampedContractForApproval":
    "合同模板和單章合同只能選擇一種發起審批",
  "devUpdates.uploadAContractTemplateOrASingleStampedContractFirst":
    "請先上傳合同模板或單章合同",
  "devUpdates.theTemplateIsEmpty": "模板內容為空",
  "devUpdates.templateSaved": "模板已儲存",
  "devUpdates.failedToSaveTemplate": "模板儲存失敗",
  "devUpdates.thisReviewerHasAlreadyBeenAdded": "該審核人已添加",
  "devUpdates.uploadTheInvInvoiceFirst": "請先上傳INV發票",
  "devUpdates.invApprovalRequested": "發起INV審批成功",
  "devUpdates.invApproved": "INV審核成功",
  "devUpdates.failedToInitializeTheSellerCompany": "初始化貨主公司失敗",
  "devUpdates.bankAddedSuccessfully": "銀行添加成功",
  "devUpdates.imageFileSizeLimit": "圖片大小不能超過10MB",
  "devUpdates.relatedContentRemoved": "已移除關聯內容",
  "devUpdates.paymentApprovalRequested": "發起付款審批成功",
  "devUpdates.mergedSuccessfully": "合併成功",
  "devUpdates.failedToSearchCompanies": "搜索公司列表失敗",
  "devUpdates.failedToLoadCompanies": "獲取公司列表失敗",
  "devUpdates.companyProfileAdded": "公司資料添加成功",
  "devUpdates.addressAdded": "地址添加成功",
  "devUpdates.addressChanged": "地址更換成功",
  "devUpdates.enterASearchKeywordFirst": "請先輸入搜索關鍵詞",
  "devUpdates.aSalesOrderCannotBeGeneratedForThisOrderYet":
    "當前訂單暫不可生成銷售訂單",
  "devUpdates.selectAtLeastOneSellerReviewer": "請選擇至少一個賣方審核人",
  "devUpdates.selectTheSellerCompany": "請選擇賣方公司",
  "devUpdates.productConditionIsRequired": "貨物情況必填",
  "devUpdates.validationFailedCheckTheFormFields": "表單驗證失敗，請檢查輸入項",
  "devUpdates.selectThePriceCurrency": "請選擇產品價格單位",
  "devUpdates.orderContractGenerated": "訂單合同生成成功",
  "devUpdates.orderIdIsMissingTheOrderCannotBeRejected": "缺少訂單ID，無法駁回",
  "devUpdates.failedToLoadData": "載入數據失敗",
  "devUpdates.installmentsCannotExceedTheAmountDue":
    "分批付款合計不能超過應付金額",
  "devUpdates.onlyOneUnpaidInstallmentCanBeAddedAtATime":
    "每次只能添加一期未支付的分期批次",
  "devUpdates.theUnpaidBalanceIsZeroNoMoreInstallmentsCanBeAdded":
    "未支付總額為0，不能繼續添加分期",
  "devUpdates.upToFiveInstallmentsAreSupported": "最多支持5期分期付款",
  "devUpdates.enterTheFirstInstallmentAmountAndPaymentDate":
    "請填寫第一期的付款金額和付款時間",
  "devUpdates.paymentMethodSubmittedForReview":
    "發起付款方式審批成功，開始付款方式審核",
  "devUpdates.uploadAPaymentReceipt": "請上傳支付憑證",
  "devUpdates.submittedToPurchasingTeam": "提交成功，已流轉至採購商務：黃心雨",
  "devUpdates.paymentReceiptConfirmed": "付款憑證已確認",
  "devUpdates.paymentMethodApproved": "付款方式審核通過",
  "devUpdates.enterAValidMobileVerificationCode": "請輸入正確的手機驗證碼",
  "devUpdates.areYouSureYouWantToLogOut": "你確認要退出登入嗎？",
  "devUpdates.logoutCancelled": "已取消退出",
  "devUpdates.linkedSuccessfully": "綁定成功",
  "devUpdates.bankDetailsCopied": "銀行資料已複製",
  "devUpdates.failedToLoadBanks": "銀行列表載入失敗",
  "devUpdates.linkedBanksUpdated": "綁定銀行已更新",
  "devUpdates.failedToUpdateLinkedBanks": "綁定銀行更新失敗",
  "devUpdates.failedToLoadSuppliers": "供應商列表載入失敗",
  "devUpdates.failedToLoadSupplierProfile": "供應商資料載入失敗",
  "devUpdates.bankCreated": "新建銀行成功",
  "devUpdates.failedToLoadBiddingInformation": "載入競標資料失敗",
  "devUpdates.selectACompanyFirst": "請先選擇公司名稱",
  "devUpdates.bankDetailsAddedAndFilledInAutomatically":
    "銀行資料已新增並自動回填",
  "devUpdates.failedToAddCompany": "添加公司失敗",
  "devUpdates.batchUploadIsComingSoon": "批量上傳功能開發中",
  "devUpdates.selectTheProductLocation": "請選擇所貨地",
  "devUpdates.selectThePublicationDate": "請選擇發佈時間",
  "devUpdates.selectTheBiddingDeadline": "請選擇截標時間",
  "devUpdates.selectTheBidOpeningTime": "請選擇開標時間",
  "devUpdates.uploadAnExcelFileFirst": "請先上傳Excel檔案",
  "devUpdates.batchPublicationFailedTryAgainLater": "批量發佈失敗，請稍後重試",
  "devUpdates.onlyXlsxAndXlsFilesAreSupported":
    "只支持 .xlsx 和 .xls 格式的檔案",
  "devUpdates.cannotReadTheExcelWorksheet": "無法讀取Excel工作表",
  "devUpdates.theExcelFileIsEmpty": "Excel檔案為空",
  "devUpdates.theExcelFileContainsNoData": "Excel檔案沒有數據",
  "devUpdates.biddingImportPartNumberColumnRequired":
    '未找到有效的競標數據，請確保Excel包含"料號"列',
  "devUpdates.failedToReadFile": "讀取檔案失敗",
  "devUpdates.completeAtLeastOneField": "請至少填寫一項資料",
  "devUpdates.selectPackaging": "請選擇包裝",
  "devUpdates.selectAPackage": "請選擇封裝",
  "devUpdates.uploadThisContractItCannotBeEditedAfterTheOtherPartyApprovesIt":
    "確認上傳合同？對方複核通過後不能再修改編輯",
  "devUpdates.relatedOrdersAdded": "關聯訂單添加成功",
  "devUpdates.approveDualStampedContractConfirmation":
    "確認雙章合同審核通過？對方複核通過後流程結束，不能再修改雙章合同。",
  "devUpdates.dualStampedContractApproved": "雙章合同審核通過",
  "devUpdates.requestInvApproval": "確認發起INV審批？",
  "devUpdates.operationSucceeded": "操作成功！",
  "devUpdates.completeTheRequiredFields": "請填寫必填字段",
  "devUpdates.quoteSubmitted": "報價成功",
  "devUpdates.relatedOrderRemoved": "已移除關聯訂單",
  "devUpdates.aSingleOrderDoesNotNeedMerging": "單個訂單不需要合併",
  "devUpdates.selectOrdersToMerge": "請選擇需要合併的訂單",
  "devUpdates.checkTheRequiredFields": "請檢查必填項！",
  "devUpdates.submitThePaymentMethodForReview":
    "確認提交付款方式審批？提交後將進入審核流程。",
  "devUpdates.paymentReceiptRejected": "付款憑證已駁回",
  "devUpdates.confirmThePaymentReceiptIsCorrectTheSupplierCanThenViewAndDownloadIt":
    "確認付款憑證無誤？確認後供應商可查看下載付款憑證",
  "devUpdates.approveThePaymentMethod": "確認通過付款方式審核？",
  "devUpdates.paymentMethodRejected": "付款方式已駁回",
  "devUpdates.enterTheBusinessEmail": "請輸入企業電郵地址",
  "devUpdates.enterTheAccountAndPassword": "請填寫賬號和密碼",
  "devUpdates.readAndAcceptTheAgreements": "請閲讀並同意相關協議",
  "devUpdates.thePasswordMustContain620Characters": "密碼長度需為6-20位",
  "devUpdates.enterTheFullCompanyName": "請填寫企業全稱",
  "devUpdates.failedToLoadBiddingReviewData": "競標審核數據讀取失敗",
  "devUpdates.failedToLoadReviewDetailsTryAgainLater":
    "審核明細載入失敗，請稍後重試",
  "devUpdates.thisWarehouseReceiptHasBeenSavedDeleteIt":
    "該入倉記錄已儲存，確認刪除嗎？",
  "devUpdates.enterDatesAndReceiptNumbersForAllWarehouseReceipts":
    "請先填寫所有入倉記錄的日期和入倉號",
  "devUpdates.imagesOrVideosAreUploadingWaitBeforeSwitchingProducts":
    "圖片或影片上傳中，請稍後再切換商品",
  "devUpdates.productNumberIsMissing": "缺少商品編號",
  "devUpdates.selectAtLeastOneProduct": "請至少選擇一個商品",
  "devUpdates.imagesOrVideosAreUploadingWaitBeforeConfirmingInspection":
    "圖片或影片上傳中，請稍後確認驗貨",
  "devUpdates.yourRoleCannotSaveInspectionImagesOrTerms":
    "當前角色不能儲存驗貨圖片和條款",
  "devUpdates.eachWarehouseReceiptQuantityMustBeGreaterThanZero":
    "每項入倉實際數量都必須大於0",
  "devUpdates.inspectionQuantityIsRequired": "驗貨數量不能為空",
  "devUpdates.currentProductSaved": "當前商品儲存成功",
  "devUpdates.theCurrentStatusDoesNotAllowInspectionConfirmation":
    "當前狀態不允許確認驗貨",
  "devUpdates.enterApprovalNotes": "請填寫審批備註",
  "devUpdates.inspectionConfirmed": "確認驗貨成功！",
  "devUpdates.theCurrentStatusDoesNotAllowRejection": "當前狀態不允許駁回",
  "devUpdates.rejectionReasonRequired": "請填寫駁回原因",
  "devUpdates.rejectedSuccessfully": "駁回成功！",
  "devUpdates.warning": "警告",
  "devUpdates.selectProductSpecificationsFirst": "請先勾選商品規格",
  "devUpdates.insufficientStockForTheSelectedSpecifications":
    "所選商品規格庫存不足",
  "devUpdates.withdrawingStopsReviewAndSavesAPrivateDraftYouCanThenEditOrDeleteIt":
    "撤回後，該詞條將停止審核並儲存為僅你可見的草稿。之後可以繼續編輯或刪除草稿。",
  "devUpdates.confirmWithdrawal": "確認撤回投稿",
  "devUpdates.submissionWithdrawnAndSavedAsADraftOutsideTheReviewQueue":
    "投稿已撤回並儲存為草稿，不再進入審核隊列",
  "devUpdates.deletingRemovesThisDraftFromMyPublicationsAndCannotBeUndone":
    "刪除後，該草稿將從“我的發佈”中移除，且無法由你恢復。",
  "devUpdates.confirmDraftDeletion": "確認刪除草稿",
  "devUpdates.draftDeleted": "草稿已刪除",
  "devUpdates.noReadableDatasheetPdfIsLinkedToThisSource":
    "該來源暫未關聯可打開的規格書 PDF",
  "devUpdates.logInToViewTheFullDatasheet": "請先登入後再查看完整規格書",
  "devUpdates.failedToLoadKnowledgeBaseDetailsTryAgainLater":
    "知識庫詳情載入失敗，請稍後重試",
  "devUpdates.entryNameCopied": "詞條名稱已複製",
  "devUpdates.failedToLoadVersionHistoryTryAgainLater":
    "歷史版本載入失敗，請稍後重試",
  "devUpdates.noPublishedHistoricalVersions": "暫無已發佈的歷史版本",
  "devUpdates.thisAccountCannotReviewWikiEntries": "當前賬號沒有百科審核權限",
  "devUpdates.aManualReviewMustApproveReturnForRevisionOrReject":
    "真實人工複核記錄只能選擇審核通過、退回修改或審核不通過",
  "devUpdates.logInBeforeSaving": "請先登入後再收藏",
  "devUpdates.noDatasheetsAvailableToDownload": "暫無可下載的規格書",
  "devUpdates.protectedDownloadIsUnavailableDownloadFromTheKnowledgeBaseProductPage":
    "該規格書暫不支持受保護下載，請從知識庫產品頁下載",
  "devUpdates.logInToDownloadTheDatasheet": "請先登入後再下載規格書",
  "devUpdates.cannotLoadDownloadCreditsTryAgainLater":
    "暫時無法獲取下載積分，請稍後重試",
  "devUpdates.confirmDatasheetDownload": "確認下載規格書",
  "devUpdates.datasheetDownloadsAreUnavailableTryAgainLater":
    "規格書下載服務暫不可用，請稍後重試",
  "devUpdates.downloadingDatasheetUnlimitedFreeDownloadsForAdministrators":
    "規格書下載中（管理員無限次免費下載）",
  "devUpdates.downloadingAPurchasedDatasheetNoCreditsDeducted":
    "規格書下載中（已購規格書，本次不扣積分）",
  "devUpdates.dataExportStarted": "數據導出已開始",
  "devUpdates.failedToLoadWikiProductsTryAgainLater":
    "百科產品載入失敗，請稍後重試",
  "devUpdates.failedToLoadMoreProductsTryAgainLater":
    "載入更多產品失敗，請稍後重試",
  "devUpdates.datasheetsMustBePdfFiles": "規格書僅支持 PDF 格式",
  "devUpdates.datasheetsMustNotExceed50Mb": "規格書不能超過 50MB",
  "devUpdates.eachWikiEntryAllowsOneDatasheetRemoveTheSelectedFileFirst":
    "每個百科詞條只能上傳一份規格書，請先移除已選檔案",
  "devUpdates.failedToLoadScheduledPublication": "載入計劃發佈內容失敗",
  "devUpdates.immediatePublicationFailed": "立即發佈失敗",
  "devUpdates.cancelScheduledPublication": "取消計劃發佈",
  "devUpdates.scheduledPublicationCancelledTheEntryWasSavedAsADraft":
    "計劃發佈已取消，詞條已儲存為草稿",
  "devUpdates.failedToCancelScheduledPublication": "取消計劃發佈失敗",
  "devUpdates.thisFileFormatIsNotSupported": "暫不支持該檔案格式",
  "devUpdates.noPublishableWikiContentRecognized": "沒有識別到可發佈的百科內容",
  "devUpdates.fileParsingFailedCheckTheFileContents":
    "檔案解析失敗，請檢查檔案內容",
  "devUpdates.requiredFieldsMissing": "請填寫必填項",
  "devUpdates.selectAFuturePublicationTime": "請選擇晚於當前時間的計劃發佈時間",
  "devUpdates.datasheetPromotionalContentWarning":
    "上傳的 PDF 疑似包含廣告或導流內容，請更換為合規的官方規格書",
  "devUpdates.thePdfIsUnrelatedToChipSpecificationsSelectTheDatasheetForThisPart":
    "上傳的 PDF 與晶片規格資料無關，請重新選擇對應型號的規格書",
  "devUpdates.datasheetTextExtractionManualReviewHint":
    "該 PDF 暫時無法提取原文，提交後將轉人工複核，不能自動發佈",
  "devUpdates.addAtLeastOneWikiEntry": "請至少填寫一條百科內容",
  "devUpdates.batchSubmissionStoppedOnFailure":
    "本批存在提交失敗的內容，已停止後續提交併保留未完成數據，請檢查後重試",
  "devUpdates.answerDeleted": "回答已刪除",
  "devUpdates.commentDeleted": "評論已刪除",
  "devUpdates.commentPublished": "評論已發佈",
  "devUpdates.newCompanyProfile": "新建公司資料",
  "devUpdates.enterCompanyDetailsCertificatesAndLinkedAccountsForPurchaseOrders":
    "錄入公司基礎資料、證照與綁定資料，用於採購訂單主體選擇",
  "devUpdates.mainlandChinaCompany": "大陸企業",
  "devUpdates.hongKongMacaoOrTaiwanCompany": "港澳台企業",
  "devUpdates.enterTextOrPasteAnImage": "請輸入文本或粘貼圖片內容",
  "devUpdates.supplierShortName": "供應商簡稱",
  "devUpdates.enterTheSupplierShortName": "請填寫供應商簡稱",
  "devUpdates.enterTheCompanyNameInEnglish": "請填寫公司名稱(英)",
  "devUpdates.companyCode": "公司編碼",
  "devUpdates.enterTheCompanyCode": "請填寫公司編碼",
  "devUpdates.legalRepresentative": "公司法人",
  "devUpdates.enterTheLegalRepresentative": "請填寫公司法人",
  "devUpdates.searchLinkedCompanies": "搜索綁定公司",
  "devUpdates.noMatchingCompanies": "未找到匹配的公司",
  "devUpdates.enterTheCompanyAddress": "請填寫公司地址",
  "devUpdates.enterTheCompanyPhoneNumber": "請填寫公司電話",
  "devUpdates.linkedBankAccounts": "綁定銀行",
  "devUpdates.noBankAccountsAvailableToLink": "無可綁定的銀行",
  "devUpdates.uploadAFrameworkAgreement": "上傳框架協議",
  "devUpdates.uploadASupplierQuestionnaire": "上傳供應商調查表",
  "devUpdates.uploadAnAuditReport": "上傳審計報告",
  "devUpdates.submitCompanyProfile": "提交公司資料",
  "devUpdates.taxIdAndMainlandChinaBankDetails": "公司税號及大陸銀行資料",
  "devUpdates.registrationNumberAndOverseasBankDetails": "登記號及境外銀行資料",
  "devUpdates.imagePreviewForRecognition": "待識別圖片預覽",
  "devUpdates.removeImageForRecognition": "移除待識別圖片",
  "devUpdates.companyAttributes": "公司屬性",
  "devUpdates.parentCompany": "主公司",
  "devUpdates.searchCompaniesToLink": "搜索需要綁定的公司",
  "devUpdates.multipleSelectionsAllowed": "可多選",
  "devUpdates.selected": "· 已選",
  "devUpdates.items": "項",
  "devUpdates.noLinkableBankAccounts": "暫無可綁定銀行",
  "devUpdates.selectCompaniesToLink": "選擇綁定公司",
  "devUpdates.searchCompanyNames": "搜索公司名稱",
  "devUpdates.enterCompanyDetailsCertificatesAndLinkedAccountsToManageSuppliers":
    "錄入公司基礎資料、證照與綁定資料，用於供應商資料管理",
  "devUpdates.smartRecognitionPdfPngAndJpg":
    "智能識別（支持pdf,png,jpg圖片格式）",
  "devUpdates.enterTextOrPasteCompanyDetails": "請輸入文本或粘貼公司資料內容",
  "devUpdates.companyLocation": "公司所在地",
  "devUpdates.selectCountryProvinceCityAndDistrict": "請選擇國家/省/市/區",
  "devUpdates.reportYear": "報告年份",
  "devUpdates.selectAYear": "請選擇年份",
  "devUpdates.searchPastConversations": "搜索歷史會話",
  "devUpdates.search": "搜索...",
  "devUpdates.newConversation": "新建對話",
  "devUpdates.noMatchingConversations": "未找到相關會話",
  "devUpdates.backToXsouAi": "回到先搜AI",
  "devUpdates.goToProfile": "前往個人主頁",
  "devUpdates.scanComingSoon": "掃一掃（開發中）",
  "devUpdates.comingSoon": "開發中",
  "devUpdates.remindersComingSoon": "提醒（開發中）",
  "devUpdates.settingsComingSoon": "設置（開發中）",
  "devUpdates.conversationActions": "會話操作",
  "devUpdates.renameConversation": "編輯對話名稱",
  "devUpdates.removeFromConversations": "從對話列表刪除",
  "devUpdates.conversationName": "對話名稱",
  "devUpdates.findInConversation": "查找聊天內容",
  "devUpdates.clearSearch": "清空搜索內容",
  "devUpdates.cancelSearch": "取消查找",
  "devUpdates.enterAKeywordToSearchThisConversation": "輸入關鍵詞查找當前對話",
  "devUpdates.noMatchingContentInThisConversation": "當前對話中未找到相關內容",
  "devUpdates.pastConversations": "歷史會話",
  "devUpdates.aiGeneratedContent": "內容由 AI 生成",
  "devUpdates.voiceCallComingSoon": "語音通話（開發中）",
  "devUpdates.speakerComingSoon": "揚聲器（開發中）",
  "devUpdates.currentConversationActions": "當前會話操作",
  "devUpdates.createAConversation": "創建新對話",
  "devUpdates.searchKeywordsAndReferences": "搜索關鍵詞和參考資料",
  "devUpdates.responseActions": "回覆操作",
  "devUpdates.copyResponse": "複製回覆",
  "devUpdates.readAloudComingSoon": "朗讀（開發中）",
  "devUpdates.readResponseAloudComingSoon": "朗讀回覆（開發中）",
  "devUpdates.saveComingSoon": "收藏（開發中）",
  "devUpdates.saveResponseComingSoon": "收藏回覆（開發中）",
  "devUpdates.shareComingSoon": "分享（開發中）",
  "devUpdates.shareResponseComingSoon": "分享回覆（開發中）",
  "devUpdates.regenerateComingSoon": "重新生成（開發中）",
  "devUpdates.regenerateResponseComingSoon": "重新生成回覆（開發中）",
  "devUpdates.generating": "正在生成",
  "devUpdates.goToLatestMessage": "回到最新訊息",
  "devUpdates.takeAPhotoOrUploadAFileComingSoon": "拍照或上傳附件（開發中）",
  "devUpdates.sendAMessage": "發訊息...",
  "devUpdates.voiceInputComingSoon": "語音輸入（開發中）",
  "devUpdates.addComingSoon": "添加（開發中）",
  "devUpdates.cancelUpload": "取消上傳",
  "devUpdates.chipPhotoToUpload": "待上傳的晶片照片",
  "devUpdates.takeAPhoto": "拍照",
  "devUpdates.retakePhoto": "重新拍照",
  "devUpdates.confirmUpload": "確認上傳",
  "devUpdates.references": "參考鏈接",
  "devUpdates.onlySourcesCitedInThisResponseAreShown":
    "僅顯示本次答案實際引用的資料。",
  "devUpdates.mainNavigation": "主要導航",
  "devUpdates.bidding": "競價",
  "devUpdates.changeLanguage": "切換語言",
  "devUpdates.celebratingTheFoundingOfThePeoplesRepublicOfChina":
    "慶祝中華人民共和國成立",
  "devUpdates.anniversary": "週年",
  "devUpdates.quickPartNumberSearch": "快捷型號搜索",
  "devUpdates.quickSearch": "快捷搜索",
  "devUpdates.copyright20172026XsouTechnology":
    "Copyright © 2017-2026 先搜科技 (",
  "devUpdates.closeHolidayGreeting": "關閉節日祝福",
  "devUpdates.xsouHolidayLogo": "XSOU節日標誌",
  "devUpdates.thisProductIsAlreadyLinked": "該商品已綁定，請勿重複綁定",
  "devUpdates.logInBeforeLinkingTheProduct": "請先登入，再綁定商品",
  "devUpdates.confirmLinking": "確認綁定",
  "devUpdates.contractApprovalSteps": "發起合同審批步驟",
  "devUpdates.copySellerInvitationLink": "複製邀請貨主鏈接",
  "devUpdates.partNumber": "商品料號：",
  "devUpdates.productId": "商品ID：",
  "devUpdates.orderAttachments": "訂單附件",
  "devUpdates.files": "個",
  "devUpdates.relatedContent": "關聯內容",
  "devUpdates.sellerReviewer": "貨主審核人",
  "devUpdates.noSellerReviewers": "暫無貨主審核人",
  "devUpdates.addReviewer": "添加審核人",
  "devUpdates.noReviewersAdded": "暫未添加審核人",
  "devUpdates.downloadContractTemplate": "下載合同模版",
  "devUpdates.generatePoPurchaseOrder": "生成PO採購訂單",
  "devUpdates.generatePiProFormaInvoice": "生成PI形式發票",
  "devUpdates.generatePlPackingList": "生成PL裝箱單",
  "devUpdates.generateInvContract": "生成INV合同",
  "devUpdates.generateDeliveryNote": "生成送貨單",
  "devUpdates.generateSalesContract": "生成銷售合同",
  "devUpdates.supplierUploadsASingleStampedContract":
    "由供應商上傳單章合同檔案",
  "devUpdates.addRelatedContent": "添加關聯內容",
  "devUpdates.noRelatedContentAdded": "暫未關聯內容",
  "devUpdates.viewDocuments": "查看資料",
  "devUpdates.documents": "資料",
  "devUpdates.previous": "上一步",
  "devUpdates.next": "下一步",
  "devUpdates.noMatchingCcRecipients": "未找到匹配的抄送人",
  "devUpdates.documentDetails": "資料詳情",
  "devUpdates.closeDocumentDetails": "關閉資料詳情",
  "devUpdates.salesOrderProducts": "銷售訂單商品",
  "devUpdates.thisPageIsCurrentlyUnavailable": "暫時無法查看該頁面",
  "devUpdates.loadingPaymentInformation": "正在載入付款資料",
  "devUpdates.paymentNotes": "付款備註",
  "devUpdates.paymentRequestNotes": "付款申請備註",
  "devUpdates.paymentApprovalWorkflow": "付款審批流程",
  "devUpdates.backToOrder": "返回訂單",
  "devUpdates.noRelatedContent": "暫無關聯內容",
  "devUpdates.purchaseOrderProducts": "採購訂單商品",
  "devUpdates.invReviewer": "INV審核人",
  "devUpdates.purchaseOrderSteps": "採購訂單填寫步驟",
  "devUpdates.switchAccount": "切換賬號",
  "devUpdates.selectProductProvider": "選擇商品提供人",
  "devUpdates.addPurchaseProduct": "添加採購商品",
  "devUpdates.enterTheProductBrand": "請填寫產品品牌名稱",
  "devUpdates.enterThePartNumber": "請填寫產品料號",
  "devUpdates.enterTheUnitPrice": "請填寫產品單價",
  "devUpdates.quantityUnit": "產品數量/單位",
  "devUpdates.enterThePurchaseQuantity": "請填寫採購數量",
  "devUpdates.productUnit": "產品單位",
  "devUpdates.enterTheProductTotal": "請填寫產品總價",
  "devUpdates.enterTheDeliveryRegion": "請填寫交貨地區",
  "devUpdates.enterTheDateCodeDc": "請輸入批次(DC)",
  "devUpdates.productConditionMultipleSelections": "貨物情況（多選）",
  "devUpdates.noPurchaseProductsAddProductsInPurchaseSettings":
    "暫無採購商品，請在採購設置中添加",
  "devUpdates.theContractNumberIsGeneratedAfterSelectingTheSellerCompany":
    "合同編號在選擇賣方公司後自動生成",
  "devUpdates.duplicatesAllowed": "允許重複",
  "devUpdates.selectADeliveryDate": "請選擇交貨日期",
  "devUpdates.asNegotiated": "按照商定",
  "devUpdates.selectAPurchaseNegotiator": "請選擇採購談判人",
  "devUpdates.estimatedCommission": "預估佣金",
  "devUpdates.enterTheEstimatedCommission": "請填寫預估佣金",
  "devUpdates.enterTheAfterSalesTerms": "請填寫售後條款",
  "devUpdates.enterOrderNotes": "請填寫訂單備註",
  "devUpdates.selectOrEnterTheCompanyName": "請選擇或填寫公司名稱",
  "devUpdates.create": "新建",
  "devUpdates.enterTheFullAddress": "請填寫詳細地址",
  "devUpdates.enterTheBankNameInEnglish": "請填寫銀行英文名稱",
  "devUpdates.enterTheBankNameInChinese": "請填寫銀行中文名稱",
  "devUpdates.enterTheAccountBank": "請填寫開戶銀行",
  "devUpdates.enterTheBankAccountNumber": "請填寫銀行賬號",
  "devUpdates.enterTheSwiftCode": "請填寫 Swift Code",
  "devUpdates.enterTheBankCode": "請填寫 Bank Code",
  "devUpdates.bankAddressChinese": "銀中地址",
  "devUpdates.enterTheBankAddressInChinese": "請填寫銀行中文地址",
  "devUpdates.bankAddressEnglish": "銀英地址",
  "devUpdates.enterTheBankAddressInEnglish": "請填寫銀行英文地址",
  "devUpdates.enterTheShippingAddress": "請填寫收貨地址",
  "devUpdates.orderSubmission": "訂單提交操作",
  "devUpdates.purchaseQuote": "採購報價",
  "devUpdates.generateOrder": "生成訂單",
  "devUpdates.selectDeliveryDate": "選擇交貨日期",
  "devUpdates.selectPurchaseNegotiator": "選擇採購談判人",
  "devUpdates.searchPurchaseNegotiators": "搜索採購談判人",
  "devUpdates.noMatchingNegotiators": "未找到匹配的談判人",
  "devUpdates.enterANameToSearchPurchaseNegotiators": "輸入姓名搜索採購談判人",
  "devUpdates.companies": "公司列表",
  "devUpdates.total": "共",
  "devUpdates.companyCountUnit": "家",
  "devUpdates.noCompanyProfiles": "暫無公司資料",
  "devUpdates.loadingOrderInformation": "正在載入訂單資料",
  "devUpdates.requestPaymentApproval": "發起付款審批",
  "devUpdates.salesOrderSteps": "銷售訂單填寫步驟",
  "devUpdates.selectTheProductBrand": "請選擇產品品牌",
  "devUpdates.enterTheSalesQuantity": "請填寫銷售數量",
  "devUpdates.selectTheDeliveryRegion": "請選擇交貨地區",
  "devUpdates.selectASalesNegotiator": "請選擇銷售談判人",
  "devUpdates.clearSalesNegotiator": "清除銷售談判人",
  "devUpdates.selectACompany": "請選擇公司名稱",
  "devUpdates.enterThePrimaryContact": "請填寫主聯絡人",
  "devUpdates.change": "更換",
  "devUpdates.clearSellerContact": "清除賣方聯絡人",
  "devUpdates.clearSellerPhoneNumber": "清除賣方聯繫電話",
  "devUpdates.enterTheSellerTaxId": "請填寫賣方公司税號",
  "devUpdates.selectABank": "請選擇銀行",
  "devUpdates.enterTheBankBranch": "請填寫開戶支行",
  "devUpdates.enterTheBankRoutingNumber": "請填寫聯行號",
  "devUpdates.clearBuyerContact": "清除買方聯絡人",
  "devUpdates.clearBuyerPhoneNumber": "清除買方聯繫電話",
  "devUpdates.enterTheBuyerTaxId": "請填寫買方公司税號",
  "devUpdates.selectAShippingAddress": "請選擇收貨地址",
  "devUpdates.salesOrderSubmission": "銷售訂單提交操作",
  "devUpdates.mergeOrderSelection": "選擇合併訂單",
  "devUpdates.selectSalesNegotiator": "選擇銷售談判人",
  "devUpdates.searchNegotiators": "搜索談判人",
  "devUpdates.negotiators": "談判人列表",
  "devUpdates.people": "人",
  "devUpdates.noNegotiators": "暫無談判人數據",
  "devUpdates.confirmOrderInformation": "確認訂單資料",
  "devUpdates.orderSummary": "訂單彙總",
  "devUpdates.contractAndDelivery": "合同與交付",
  "devUpdates.backToEdit": "返回修改",
  "devUpdates.purchaseDetails": "訂購詳情",
  "devUpdates.tradeInformation": "交易資料",
  "devUpdates.purchaseQuantity": "訂購數量",
  "devUpdates.buyerWechat": "買家微信",
  "devUpdates.orderTime": "訂購時間",
  "devUpdates.productDocuments": "產品資料",
  "devUpdates.sellerWechat": "貨主微信",
  "devUpdates.negotiatorPhoneNumber": "談判人流動電話號碼",
  "devUpdates.generateContract": "生成合同",
  "devUpdates.generateTradeContract": "生成交易合同",
  "devUpdates.tradePrice": "成交價",
  "devUpdates.tradeQuantity": "成交數量",
  "devUpdates.buyerTransactionFee": "買家成單費用",
  "devUpdates.sellerTransactionFee": "貨主成單費用",
  "devUpdates.productAmount": "商品金額",
  "devUpdates.amountDue": "應付金額",
  "devUpdates.readOnly": "只讀",
  "devUpdates.paymentAmount": "本次付款金額",
  "devUpdates.submittingPaysTheFullAmountDueInOnePayment":
    "提交後將按訂單應付總額一次性完成付款",
  "devUpdates.completeOrder": "完結訂單",
  "devUpdates.deleteInstallment": "刪除該期",
  "devUpdates.installmentName": "分期名稱",
  "devUpdates.enterTheInstallmentName": "請輸入分期名稱",
  "devUpdates.requestedInstallmentAmount": "本期申請支付金額",
  "devUpdates.enterThePaymentAmount": "請輸入付款金額",
  "devUpdates.percentage": "佔比",
  "devUpdates.paymentDate": "付款時間",
  "devUpdates.selectAPaymentDate": "請選擇付款時間",
  "devUpdates.selectTheOrderingCompany": "請選擇下單公司",
  "devUpdates.paymentBank": "付款銀行",
  "devUpdates.selectAPaymentBank": "請選擇付款銀行",
  "devUpdates.addInstallment": "添加分期",
  "devUpdates.onlyOneInstallmentCanBeAddedAtATime": "每次僅可新增 1 期",
  "devUpdates.orderTotal": "訂單總額",
  "devUpdates.orderTotalPaid": "訂單總額已支付",
  "devUpdates.receivingAccount": "收款賬戶",
  "devUpdates.syncAttachments": "同步附件",
  "devUpdates.paymentMethodAttachments": "付款方式附件",
  "devUpdates.paymentMethodNotes": "付款方式備註",
  "devUpdates.enterPaymentMethodNotes": "請填寫付款方式備註",
  "devUpdates.orderNumber": "訂單號：",
  "devUpdates.installmentAmountDue": "本期應付金額",
  "devUpdates.approve": "通過審核",
  "devUpdates.submitPaymentReceipt": "提交付款憑證",
  "devUpdates.confirmPaymentReceipt": "確認付款憑證",
  "devUpdates.selectPaymentDate": "選擇付款日期",
  "devUpdates.selectOrderingCompany": "選擇下單公司",
  "devUpdates.enterACompanyNameToSearch": "輸入公司名稱進行模糊查詢",
  "devUpdates.searching": "查詢中...",
  "devUpdates.matchingCompanyListEmpty": "暫無匹配公司",
  "devUpdates.selectPaymentBank": "選擇付款銀行",
  "devUpdates.noPaymentBanks": "暫無付款銀行",
  "devUpdates.rejectPaymentMethod": "駁回付款方式",
  "devUpdates.poster": "海報",
  "devUpdates.passwordlessLogin": "免密登入",
  "devUpdates.wechatQrCode": "微信二維碼",
  "devUpdates.scanWithWechatToLogInOrSignUp": "打開微信掃一掃，快速登入/註冊",
  "devUpdates.byLoggingInOrSigningUpYouAgreeTo": "登入/註冊即代表同意",
  "devUpdates.and": "與",
  "devUpdates.orderAmount": "訂單金額：",
  "devUpdates.created": "創建時間：",
  "devUpdates.tradeDetailsAreIncomplete": "交易詳情內容待補充完整",
  "devUpdates.type": "類型：",
  "devUpdates.noContent": "暫無內容",
  "devUpdates.remaining": "餘",
  "devUpdates.inspectionWorkflow": "驗貨流程",
  "devUpdates.businessInspection": "商務驗貨",
  "devUpdates.supervisorConfirmation": "監督確認",
  "devUpdates.inspectionCompleted": "驗貨完成",
  "devUpdates.productDirectory": "商品目錄",
  "devUpdates.products": "個商品",
  "devUpdates.batchActions": "批量操作",
  "devUpdates.rejectionReason": "駁回原因：",
  "devUpdates.failedToLoadInspectionInformation": "驗貨資料載入失敗",
  "devUpdates.quantityNotReceived": "未入倉數量",
  "devUpdates.quantityReceived": "已入倉數量",
  "devUpdates.warehouseReceiptDetails": "入倉明細",
  "devUpdates.addWarehouseReceipt": "添加入倉",
  "devUpdates.syncOtherProducts": "同步其他商品",
  "devUpdates.warehouseReceiptDate": "入倉日期",
  "devUpdates.warehouseReceiptNumber": "入倉號",
  "devUpdates.enterTheWarehouseReceiptNumber": "請輸入入倉號",
  "devUpdates.actualQuantity": "實際數量",
  "devUpdates.deleteWarehouseReceipt": "刪除入倉記錄",
  "devUpdates.inspectionDocuments": "驗貨資料",
  "devUpdates.uploading": "上傳中",
  "devUpdates.unopenedProductDetails": "未拆封細節",
  "devUpdates.unopenedPackaging": "未拆封包裝",
  "devUpdates.photos": "圖 ·",
  "devUpdates.openedProductDetails": "已拆封細節",
  "devUpdates.additionalInspectionTerms": "補充驗貨條款",
  "devUpdates.enterAdditionalInspectionTerms": "請輸入補充驗貨條款",
  "devUpdates.approvalNotes": "審批備註",
  "devUpdates.loadingInspectionInformation": "正在載入驗貨資料",
  "devUpdates.enterRejectionReason": "填寫駁回原因",
  "devUpdates.enterTheReason": "請輸入具體原因",
  "devUpdates.confirmRejection": "確認駁回",
  "devUpdates.enterTheSupplierName": "請輸入供應商名稱",
  "devUpdates.add": "新增",
  "devUpdates.filterByLinkedBank": "綁定銀行篩選",
  "devUpdates.allBanks": "全部銀行",
  "devUpdates.suppliers": "供應商列表",
  "devUpdates.resetFilters": "重置篩選",
  "devUpdates.parentCompanyName": "主公司名稱",
  "devUpdates.contactInformation": "聯繫資料",
  "devUpdates.supplierBankDetails": "供應商銀行資料",
  "devUpdates.accounts": "個賬戶",
  "devUpdates.subsidiaryName": "子公司名稱",
  "devUpdates.businessRegistrationCertificate": "商業登記證",
  "devUpdates.auditReport": "審計報告",
  "devUpdates.purchaseAgreement": "採購協議",
  "devUpdates.questionnaire": "調查表",
  "devUpdates.profileCreatedLabel": "建檔日期：",
  "devUpdates.expires": "到期：",
  "devUpdates.noSuppliers": "暫無供應商數據",
  "devUpdates.addSupplier": "新增供應商",
  "devUpdates.supplierActions": "供應商操作",
  "devUpdates.addBank": "新建銀行",
  "devUpdates.addAddress": "新增地址",
  "devUpdates.changeAddress": "更換地址",
  "devUpdates.deleteSupplier": "刪除供應商",
  "devUpdates.supplierDetails": "供應商詳情",
  "devUpdates.documentFiles": "資料檔案",
  "devUpdates.contactDetails": "聯絡人資料",
  "devUpdates.bankName": "銀行名稱",
  "devUpdates.noSupplierBankDetails": "暫無供應商銀行資料",
  "devUpdates.noLinkedBanks": "暫未綁定銀行",
  "devUpdates.subsidiaryInformation": "子公司資料",
  "devUpdates.tradeStatus": "交易狀態",
  "devUpdates.noSubsidiaries": "暫無子公司資料",
  "devUpdates.selectOurBankAccountsAvailableToThisSupplier":
    "選擇該供應商可使用的我方銀行賬戶",
  "devUpdates.bankAccountLinkOptionsEmpty": "暫無可綁定的銀行",
  "devUpdates.saveLinkedAccounts": "儲存綁定",
  "devUpdates.selectBank": "選擇銀行",
  "devUpdates.noBankDetailsForThisCompany": "當前公司暫無銀行資料",
  "devUpdates.publishBidding": "競標發佈",
  "devUpdates.backToBidding": "返回競標",
  "devUpdates.batchUpload": "批量上傳",
  "devUpdates.privacyProtection": "隱私保護",
  "devUpdates.createCompanyProfileAction": "+ 新建公司資料",
  "devUpdates.enterTheReceivingAccountNumber": "請填寫收款賬號",
  "devUpdates.publisher": "資料發佈者",
  "devUpdates.selectABusinessTeamMember": "請選擇業務組人員",
  "devUpdates.selectAWeekIn2026": "選擇26年的第幾週",
  "devUpdates.selectStatus": "選擇狀態",
  "devUpdates.productLocation": "所貨地",
  "devUpdates.selectRegion": "選擇地區",
  "devUpdates.factorySealed": "原封",
  "devUpdates.other": "其它",
  "devUpdates.enterNotes": "請填寫備註資料",
  "devUpdates.details": "詳細資料",
  "devUpdates.productIdLink": "商品ID/鏈接",
  "devUpdates.enterTheProductIdOrLink": "請填寫商品ID或鏈接",
  "devUpdates.specificationDatasheet": "規格書 / 數據手冊",
  "devUpdates.uploadExcelFilesInBulk": "批量上傳Excel檔案",
  "devUpdates.dropAnExcelFileHereOr": "將Excel檔案拖到此處，或",
  "devUpdates.supportsXlsxAndXls": "支持 .xlsx, .xls 格式",
  "devUpdates.parsed": "已解析",
  "devUpdates.records": "條數據",
  "devUpdates.remainingPrefix": "還有",
  "devUpdates.moreRecords": "條數據...",
  "devUpdates.bidLot": "標單",
  "devUpdates.code": "編碼",
  "devUpdates.enterTheCode": "請填寫編碼",
  "devUpdates.selectProductCategory": "選擇產品分類",
  "devUpdates.enterCapacity": "請填寫容量",
  "devUpdates.selectPackage": "選擇封裝",
  "devUpdates.selectTechnology": "選擇技術",
  "devUpdates.enterStockQuantity": "請填寫庫存",
  "devUpdates.packagingSelection": "選擇包裝",
  "devUpdates.duplicateProductBindingNotAllowed":
    "該商品已綁定，請勿重複綁定商品",
  "devUpdates.pleaseFirstPrefix": "請先",
  "devUpdates.beforeLinkingTheProduct": "，再綁定商品",
  "devUpdates.published": "發佈時間：",
  "devUpdates.publishSupplyDemand": "供需發佈",
  "devUpdates.registerABrand": "品牌入駐",
  "devUpdates.view": "視圖：",
  "devUpdates.brandCategory": "品牌分類：",
  "devUpdates.region": "地區：",
  "devUpdates.sort": "排序：",
  "devUpdates.productCount": "產品數",
  "devUpdates.popularity": "熱度",
  "devUpdates.founded": "成立年份",
  "devUpdates.companyCount": "企業數",
  "devUpdates.orders": "訂單數",
  "devUpdates.viewProducts": "查看產品",
  "devUpdates.brandName": "品牌名",
  "devUpdates.brandIntroduction": "品牌簡介",
  "devUpdates.active": "已生效",
  "devUpdates.noMatchingBrands": "暫無相關品牌資料",
  "devUpdates.productDetails": "商品明細",
  "devUpdates.addDifferentBrandsPartNumbersQuantitiesAndUnitPrices":
    "同一產品可添加不同品牌、料號、數量和單價",
  "devUpdates.addProduct": "添加商品",
  "devUpdates.unitPrice": "單價：",
  "devUpdates.noOrderAttachments": "暫無訂單附件",
  "devUpdates.contractApprovalInformation": "發起合同審批資料",
  "devUpdates.contractApprovalOverview": "合同審批資料",
  "devUpdates.completePaymentReviewerAndContractFileInformation":
    "補充付款、審核人與合同檔案資料",
  "devUpdates.approvalAndRelatedContent": "審批與關聯",
  "devUpdates.removeReviewer": "移除審核人",
  "devUpdates.contractFiles": "合同檔案",
  "devUpdates.downloadContractTemplateAction": "下載合同模板",
  "devUpdates.generatePoPurchaseContract": "生成PO採購合同",
  "devUpdates.moreSalesOrderInformation": "更多銷售訂單資料",
  "devUpdates.buyerType": "買方類型",
  "devUpdates.recipientPhoneNumber": "收貨人電話",
  "devUpdates.totalPrice": "總價",
  "devUpdates.moreDocuments": "更多資料",
  "devUpdates.viewSpecification": "點擊查看規格書",
  "devUpdates.enter": "輸入",
  "devUpdates.aNameToSearchAndAdd": "姓名搜索並添加",
  "devUpdates.noSearchResults": "無搜索結果",
  "devUpdates.buyerAndSellerInformation": "買賣雙方資料",
  "devUpdates.checkTradingPartiesBankDetailsAndPaymentAttachments":
    "核對交易主體、銀行資料及付款相關附件",
  "devUpdates.paymentDocuments": "付款檔案",
  "devUpdates.viewTradeContractsAndUploadDocumentsRequiredForPayment":
    "集中查看交易合同，並上傳付款流程所需檔案",
  "devUpdates.tradeContractPo": "交易合同（PO）",
  "devUpdates.productAndPurchaseInformation": "商品與採購資料",
  "devUpdates.confirmTheProviderNegotiatorAndPurchaseProducts":
    "確認商品提供人、談判人和本次採購商品",
  "devUpdates.selectAProductProvider": "請選擇商品提供人",
  "devUpdates.completeProductTradeFieldsArrangedInFourColumns":
    "完整展示商品交易字段，四列排布提升填寫效率",
  "devUpdates.confirmContractNumberDeliveryDateOrderTypeAndNotes":
    "確認合同編號、交貨日期、訂單類型與補充説明",
  "devUpdates.enterTheContractNumber": "請填寫合同編號",
  "devUpdates.completeSellerCompanyContactAddressAndBankDetails":
    "完整展示賣方公司、聯絡人、地址與銀行資料",
  "devUpdates.showHiddenInformation": "展開隱藏資料",
  "devUpdates.sellerCompanyTaxIdRequired": "請填寫賣公司税號",
  "devUpdates.enterTheBankName": "請填寫銀行名稱",
  "devUpdates.swiftCodeRequired": "請填寫Swift Code",
  "devUpdates.bankCodeRequired": "請填寫Bank Code",
  "devUpdates.bankEnglishAddressRequired": "請填寫銀英地址",
  "devUpdates.completeBuyerCompanyContactAndShippingDetails":
    "完整展示買方公司、聯絡人與收貨資料",
  "devUpdates.buyerCompanyTaxIdRequired": "請填寫買公司税號",
  "devUpdates.addNotesForThisPurchaseOrderRequest": "補充本次採購訂單申請備註",
  "devUpdates.confirmInformationRequestAPurchaseQuoteThenGenerateTheOrder":
    "確認資料後執行採購報價，報價完成後生成訂單",
  "devUpdates.piProFormaInvoice": "PI（形式發票）",
  "devUpdates.ciCommercialInvoice": "CI（正式發票）",
  "devUpdates.quantity": "數量(",
  "devUpdates.selectOrdersForTheSameBuyerToMergeIntoASalesOrder":
    "勾選同一買方下的訂單，合併後統一生成銷售訂單",
  "devUpdates.editSalesProductsPricesQuantitiesDeliveryRegionsAndConditions":
    "維護銷售商品、價格、數量、交貨地區與貨物情況",
  "devUpdates.enterTheUnit": "請填寫單位",
  "devUpdates.orderDocuments": "訂單資料",
  "devUpdates.currentOrder": "當前訂單：",
  "devUpdates.uploaded": "已上傳",
  "devUpdates.confirmContractNumberDeliveryDateOrderTypeNegotiatorAfterSalesTermsAndPaymentMethod":
    "確認合同編號、交貨日期、訂單類型、談判人、售後條款與付款方式",
  "devUpdates.addNotesForThisSalesOrderRequest": "補充本次銷售訂單申請備註",
  "devUpdates.thePurchasingTeamCanGenerateASalesOrderAfterRequestingAQuote":
    "採購商務點擊採購報價後即可生成銷售訂單",
  "devUpdates.orderContractInformation": "訂單 / 合同資料",
  "devUpdates.tradingParties": "交易雙方",
  "devUpdates.showTradingParties": "展開交易雙方",
  "devUpdates.payInFull": "全額支付",
  "devUpdates.payInInstallments": "分批支付",
  "devUpdates.completeOrderAfterFullPayment": "付完完結訂單",
  "devUpdates.enterTheOrderingCompanyToSearch": "請輸入下單公司查詢",
  "devUpdates.reviewNumber": "審核單號",
  "devUpdates.partNumbersInThisReview": "本單料號",
  "devUpdates.totalStock": "庫存合計",
  "devUpdates.partNumberCount": "料號數量",
  "devUpdates.selectedParticipants": "入選用戶",
  "devUpdates.totalQuantity": "彙總數量",
  "devUpdates.settlementAmount": "結算金額",
  "devUpdates.biddingRules": "競標規則",
  "devUpdates.publicationStatus": "發佈狀態",
  "devUpdates.commissionMethod": "佣金方式",
  "devUpdates.commissionRate": "佣金比例",
  "devUpdates.participationLevel": "參與等級",
  "devUpdates.publishingCompany": "發佈公司",
  "devUpdates.submissionMethod": "提交方式",
  "devUpdates.publicationNotes": "發佈備註",
  "devUpdates.partNumberInformation": "料號資料",
  "devUpdates.productAttributes": "商品屬性",
  "devUpdates.stockAndPackaging": "庫存與包裝",
  "devUpdates.locationAndCondition": "所在地與貨況",
  "devUpdates.loadingMoreReviewDetails": "正在載入更多審核明細",
  "devUpdates.backToTop": "回到頁面頂部",
  "devUpdates.perPage": "每頁",
  "devUpdates.productLocationLabel": "所貨地：",
  "devUpdates.packaging": "裝箱：",
  "devUpdates.stock": "庫存：",
  "devUpdates.selectedParticipantsLabel": "入選用戶：",
  "devUpdates.submitted": "提交：",
  "devUpdates.selectedBidders": "入選競標用戶",
  "devUpdates.confirmedMinimumPrice": "確認最低價：",
  "devUpdates.totalQuantityLabel": "彙總數量：",
  "devUpdates.feeMethod": "費用方式：",
  "devUpdates.reviewWorkflow": "審核流程",
  "devUpdates.enterReviewNotes": "請填寫本次審核備註",
  "devUpdates.loadingReviewDetails": "正在載入審核明細",
  "devUpdates.reviewNotFound": "未找到該審核單",
  "devUpdates.backToReviews": "返回審核列表",
  "devUpdates.pleaseCheckAll": "請核對全部",
  "devUpdates.informationBeforeConfirmingTheReview": "資料後確認審核",
  "devUpdates.productSpecifications": "商品規格",
  "devUpdates.pagePath": "頁面路徑",
  "devUpdates.inspectionProgress": "驗貨進度",
  "devUpdates.productInformationAndWarehouseReceipts": "產品資料與入倉記錄",
  "devUpdates.automaticallyTotaled": "· 自動彙總",
  "devUpdates.applyToAll": "統一",
  "devUpdates.enterTheActualQuantity": "請輸入實際數量",
  "devUpdates.videos": "· 影片",
  "devUpdates.noVideos": "暫無影片",
  "devUpdates.additionalInspectionTermsRequired": "請填寫補充驗貨條款",
  "devUpdates.enterSpecificRejectionReason": "請輸入具體的駁回原因",
  "devUpdates.manageSupplierProfilesContactsBanksAndAddresses":
    "管理供應商資料及聯絡人、銀行、地址等資料",
  "devUpdates.selectLinkedBankAccounts": "請選擇綁定銀行",
  "devUpdates.purchaseFrameworkAgreement": "採購框架協議",
  "devUpdates.copySupplierBankDetails": "複製供應商銀行資料",
  "devUpdates.subsidiaryDetails": "子公司明細",
  "devUpdates.expiryDate": "到期日期",
  "devUpdates.ourLinkedBankAccounts": "我方綁定銀行",
  "devUpdates.profileCreated": "建檔日期",
  "devUpdates.supplierQuestionnaire": "供應商調查表",
  "devUpdates.createAddress": "新建地址",
  "devUpdates.bankLogo": "銀行 logo",
  "devUpdates.subsidiaries": "家子公司",
  "devUpdates.bankAccounts": "個銀行賬戶",
  "devUpdates.companyCodePlaceholder": "請輸入公司編碼",
  "devUpdates.legalRepresentativePlaceholder": "請輸入公司法人",
  "devUpdates.companyContact": "公司聯絡人",
  "devUpdates.enterTheCompanyContact": "請輸入公司聯絡人",
  "devUpdates.enterContactDetails": "請輸入聯絡方式",
  "devUpdates.fullAddress": "詳細地址",
  "devUpdates.fullAddressPlaceholder": "請輸入詳細地址",
  "devUpdates.bankNamePlaceholder": "請輸入銀行名稱",
  "devUpdates.receivingAccountPlaceholder": "請輸入收款賬號",
  "devUpdates.bankAccountNumber": "開戶行賬號",
  "devUpdates.bankAccountPlaceholder": "請輸入開戶行賬號",
  "devUpdates.bankAddress": "銀行地址",
  "devUpdates.enterTheBankAddress": "請輸入銀行地址",
  "devUpdates.swiftCodePlaceholder": "請輸入swift code",
  "devUpdates.bankCodePlaceholder": "請輸入bank code",
  "devUpdates.notesPlaceholder": "請輸入備註",
  "devUpdates.confirm": "確 定",
  "devUpdates.cancel": "取 消",
  "devUpdates.onlineInquiry": "在線諮詢",
  "devUpdates.selectSpecifications": "選擇規格",
  "devUpdates.remainingStock": "剩餘庫存：",
  "devUpdates.smartSearchResults": "” 的智能搜索結果",
  "devUpdates.generatedLiveByXsouAiVerifyKeyParametersAgainstTheProductDatasheet":
    "答案由先搜AI實時生成，請結合產品規格書核驗關鍵參數。",
  "devUpdates.found": "找到",
  "devUpdates.resultsFor": "條與 “",
  "devUpdates.relatedSearchClosingQuote": "” 相關的",
  "devUpdates.results": "結果",
  "devUpdates.wikiContentIsBeingGeneratedAndWillAppearWhenReady":
    "百科內容正在生成，完成後將自動顯示。",
  "devUpdates.answers": "條回答",
  "devUpdates.viewAllQA": "查看全部問答",
  "devUpdates.closeEnlargedImage": "關閉大圖",
  "devUpdates.chipWikiEntryNotFound": "未找到對應晶片百科",
  "devUpdates.backToChipWiki": "返回百科列表",
  "devUpdates.generatedLiveByXsouAi": "由先搜AI實時生成",
});

// 通用业务用语
export const business = Object.freeze({
  "business.goodsCenter": "商品中心",
  "business.goodsCenterDescription": "集中查看與管理已發佈商品",
  "business.publishedGoods": "發佈商品",
  "business.searchAll": "全部搜索",
  "business.searchName": "名稱搜索",
  "business.searchPartNumber": "料號搜索",
  "business.searchSuffix": "搜索",
  "business.nameAndPartNumber": "名稱、料號",
  "business.name": "名稱",
  "business.partNumber": "料號",
  "business.viewDetails": "查看詳情",
  "business.editGoods": "修改商品資料",
  "business.editBuyerPhone": "修改買家號碼",
  "business.editSaleRange": "修改可售範圍",
  "business.inviteBuyerLink": "邀請買家鏈接",
  "business.noGoods": "暫無商品數據",
  "business.noMoreGoods": "沒有更多商品了",
  "business.loading": "載入中...",
  "business.price": "價格",
  "business.enterPrice": "請填寫價格",
  "business.cny": "人民幣",
  "business.usd": "美元",
  "business.quantity": "數量",
  "business.enterQuantity": "請填寫數量",
  "business.validUntil": "有效期",
  "business.selectValidUntil": "請選擇有效期",
  "business.submitChanges": "提交修改",
  "business.editBuyerMobile": "修改買家流動電話號碼",
  "business.buyerMobile": "買家流動電話號碼",
  "business.addMobile": "新增流動電話號碼",
  "business.enterMobile": "請輸入流動電話號碼",
  "business.set": "設置",
  "business.add": "添加",
  "business.currentBuyerMobile": "當前買家流動電話號碼",
  "business.addedMobile": "已添加流動電話號碼",
  "business.noMobile": "暫無流動電話號碼",
  "business.cancel": "取消",
  "business.confirmChanges": "確認修改",
  "business.confirmAdd": "確認添加",
  "business.purchaseBusiness": "採購商務",
  "business.purchaseNegotiator": "採購談判人",
  "business.mobileAlreadyExists": "該流動電話號碼已存在",
  "business.onlyOneMobile": "該商品只支持添加一個流動電話號碼",
  "business.changesSaved": "修改成功",
  "business.changesFailed": "修改失敗",
  "business.copySuccess": "複製成功",
  "business.copyFailed": "複製失敗",
  "business.oneChangeRequired": "請至少填寫價格、數量或有效期其中一項",
  "business.retryChanges": "修改失敗，請稍後重試",
  "business.goodsLoadFailed": "商品載入失敗",
  "business.retryGoodsLoad": "商品載入失敗，請稍後重試",
  "business.sellerTitle": "我是貨主",
  "business.image": "圖片",
  "business.productName": "產品名稱",
  "business.specPartNumber": "規格料號",
  "business.totalQuantity": "總數量",
  "business.remainingQuantity": "餘量",
  "business.negotiator": "談判人",
  "business.contact": "聯絡方式",
  "business.publishedAt": "發佈時間",
  "business.action": "操作",
  "business.myInfo": "我的資料",
  "business.clueType": "線索類型",
  "business.selectType": "請選擇類型",
  "business.title": "標題",
  "business.brand": "品牌",
  "business.unitPrice": "單價",
  "business.seller": "貨主",
  "business.wechat": "微信",
  "business.mobile": "流動電話號碼",
  "business.clueStatus": "資料狀態",
  "business.time": "時間",
  "business.draft": "草稿中",
  "business.pendingReview": "待審核",
  "business.reviewed": "已審核",
  "business.published": "已發佈",
  "business.ended": "已終止",
  "business.supplyInfo": "貨源資料",
  "business.buyRequestInfo": "求購資料",
  "business.all": "全部",
  "business.supply": "貨源",
  "business.buyRequest": "求購",
  "business.myClues": "我發佈的線索",
  "business.noData": "暫無數據",
  "business.noMore": "我們是有底線的",
  "business.currentStatus": "當前狀態",
  "business.completeInfo": "資料完善",
  "business.details": "詳情",
  "business.mySalesGoods": "我銷售的商品",
  "business.biddingManagement": "競標管理",
  "business.biddingList": "競標列表",
  "business.bidExport.selectFirst": "請先勾選要導出的競標數據",
  "business.bidExport.priceColumn": "下標價格",
  "business.bidExport.totalColumn": "總額",
  "business.bidExport.remarkColumn": "備註",
  "business.bidExport.filePrefix": "競標下單",
  "business.bidExport.success": "已導出 {count} 條競標數據",
  "business.bidExport.failed": "導出失敗，請重試",
  "business.searchBidding": "搜索料號/品牌/編號",
  "business.card": "卡片",
  "business.list": "列表",
  "business.customerName": "客戶名稱",
  "business.bidQuantity": "競標數量",
  "business.bidPrice": "競標價格",
  "business.view": "查看",
  "business.noBidding": "暫無競標資料",
  "business.bidNumber": "編號",
  "business.period": "期數",
  "business.type": "類型",
  "business.status": "狀態",
  "business.biddingTime": "競標時間",
  "business.noMoreBidding": "沒有更多了",
  "business.publishBid": "發佈競標",
  "business.searchPublishedBid": "搜索料號、品牌、編號...",
  "business.referencePrice": "參考價",
  "business.edit": "修改",
  "business.delete": "刪除",
  "business.noPublishedBid": "暫無發佈競標資料",
  "business.myBids": "我的競標",
  "business.viewToggle": "視圖切換",
  "business.cardView": "卡片視圖",
  "business.listView": "列表視圖",
  "business.switchCardView": "切換為卡片視圖",
  "business.switchListView": "切換為列表視圖",
  "business.searchBidProject": "搜索競標項目",
  "business.allBids": "全部",
  "business.openBids": "競標中",
  "business.closedBids": "已截標",
  "business.openedBids": "已開標",
  "business.wonBids": "已中標",
  "business.lostBids": "未中標",
  "business.productCategory": "產品分類",
  "business.technology": "技術",
  "business.capacity": "容量",
  "business.bidUnitPrice": "競標單價",
  "business.editBid": "修改競標",
  "business.editOnlyOpen": "僅競標中可以修改",
  "business.statusAndId": "狀態 / 編號",
  "business.productInfo": "產品資料",
  "business.goodsInfo": "貨物資料",
  "business.timeInfo": "時間資料",
  "business.bidInfo": "競標資料",
  "business.location": "所在地",
  "business.packaging": "包裝",
  "business.package": "封裝",
  "business.bidDeadline": "截標",
  "business.bidOpen": "開標",
  "business.level": "等級",
  "business.participants": "人數",
  "business.bidDialog.viewDetails": "查看詳情",
  "business.bidDialog.favorite": "收藏競標",
  "business.bidDialog.share": "分享競標",
  "business.bidDialog.basicInfo": "基本資料",
  "business.bidDialog.stockLocation": "貨所在地",
  "business.bidDialog.stock": "庫存",
  "business.bidDialog.currency": "貨幣",
  "business.bidDialog.referenceUnitPrice": "參考單價",
  "business.bidDialog.quoteInfo": "競價資料",
  "business.bidDialog.myQuote": "我的報價",
  "business.bidDialog.enterQuote": "請輸入報價",
  "business.bidDialog.requiredQuantity": "需求數量",
  "business.bidDialog.maximum": "最大可輸入：{count}",
  "business.bidDialog.submit": "提交競價",
  "business.bidDialog.history": "競價歷史記錄",
  "business.bidDialog.noHistory": "暫無競價歷史記錄",
  "business.bidDialog.quote": "報價",
  "business.bidDialog.totalPrice": "貨品總價",
  "business.bidDialog.commission": "佣金({percent}%·{mode})",
  "business.bidDialog.commissionLabel": "佣金",
  "business.bidDialog.payable": "應付",
  "business.bidDialog.deducted": "內扣",
  "business.bidDialog.added": "外加",
});

export const sharedUi = Object.freeze({
  "sharedUi.partNumberPrefix": "料號：",
  "sharedUi.added": "已添加",
  "sharedUi.item": "項目",
  "sharedUi.editSucceeded": "編輯成功",
  "sharedUi.completeRequired": "請檢查並完善必填資訊",
  "sharedUi.confirmationFailed": "確認失敗",
  "sharedUi.skipLogin": "暫不登入",
  "sharedUi.closeDialog": "關閉{title}彈窗",
  "sharedUi.closeDetails": "關閉{title}",
});

export const sharedFlowUi = Object.freeze({
  "sharedUi.required": "必傳",
  "sharedUi.optional": "選填",
});

export const messages = Object.freeze({
"loginBindings.bindTitle": "綁定{account}",
"loginBindings.bind": "去綁定",
"loginBindings.scan": "請使用微信掃描二維碼完成綁定",
"loginBindings.country": "手機區號",
"loginBindings.code": "驗證碼",
"loginBindings.send": "取得驗證碼",
"loginBindings.confirm": "確認綁定",

"loginBindings.title": "登入綁定",
"loginBindings.phone": "手機號碼",
"loginBindings.email": "電郵",
"loginBindings.wechat": "微信",
"loginBindings.wecom": "企業微信",
"loginBindings.google": "Google",
"loginBindings.bound": "已關聯",
"loginBindings.unbound": "未關聯",
"loginBindings.failed": "綁定資訊載入失敗",
"loginBindings.retry": "重試",

"passwordReset.phone": "手機號碼",
"passwordReset.email": "電郵",
"passwordReset.smsCode": "短訊驗證碼",
"passwordReset.emailCode": "電郵驗證碼",

  "passwordReset.title": "忘記密碼",
  "passwordReset.account": "手機號碼 / 電郵",
  "passwordReset.code": "驗證碼",
  "passwordReset.send": "取得驗證碼",
  "passwordReset.resend": "{seconds}秒後重發",
  "passwordReset.password": "新密碼（8至20位）",
  "passwordReset.confirmPassword": "確認新密碼",
  "passwordReset.submit": "重設密碼",
  "passwordReset.saving": "提交中",
  "passwordReset.invalidAccount": "請輸入正確的手機號碼或電郵",
  "passwordReset.invalidCode": "請輸入4位數字驗證碼",
  "passwordReset.passwordLength": "密碼長度需為8-20位",
  "passwordReset.mismatch": "兩次輸入的密碼不一致",
  "passwordReset.sent": "驗證碼已發送",
  "passwordReset.success": "密碼已重設，請使用新密碼登入",
  "passwordReset.failed": "操作失敗，請稍後重試",

  "authnMerge.regions": "實名認證短訊目前僅支援中國內地及中國香港，其他地區待接入。",
  "authnMerge.notice": "請使用本人手機號碼驗證。如該號碼已有帳戶，提交後將合併登入身份至該帳戶並切換登入；身份或實名資料衝突時不會覆蓋。",
  "recentFlow.receiptFailure": "收貨操作失敗，請重試",
  "recentFlow.batchInvalid": "發貨批次資料異常，請重試",
  "recentFlow.historyFailure": "發貨記錄載入失敗，請重試",
  "recentFlow.supplierQuantityInvalid": "商品訂單ID必須有效，發貨數量必須為正整數",
  "recentFlow.outboundQuantityInvalid": "商品訂單、出庫明細ID必須有效，發貨數量必須為正整數，請重新查詢出庫單",
  "recentFlow.uploadPending": "發貨憑證尚未上傳完成，請等待上傳完成後提交",

  "recentFlow.name": "商品名稱",
  "recentFlow.brand": "品牌",
  "recentFlow.model": "料號",
  "recentFlow.price": "價格",
  "recentFlow.quantity": "數量",
  "recentFlow.code": "商品編號",
  "recentFlow.placed": "已下單",
  "recentFlow.processing": "製單中",
  "recentFlow.completed": "已完成",
  "recentFlow.purchase": "採購",
  "recentFlow.sales": "銷售",

  "recentFlow.confirm": "確認收貨",
  "recentFlow.orderNumber": "訂單號：",
  "recentFlow.hint": "請核對每批物流及商品數量，按實際到貨批次確認收貨。",
  "recentFlow.loading": "正在載入發貨資料…",
  "recentFlow.reload": "重新載入",
  "recentFlow.empty": "暫無發貨批次",
  "recentFlow.received": "已收貨",
  "recentFlow.waiting": "待收貨",
  "recentFlow.shippedAt": "發貨時間",
  "recentFlow.company": "物流公司",
  "recentFlow.tracking": "物流單號",
  "recentFlow.remark": "發貨備註",
  "recentFlow.receivedAt": "收貨時間",
  "recentFlow.modelMissing": "未填寫型號",
  "recentFlow.unit": "件",
  "recentFlow.voucher": "發貨憑證",
  "recentFlow.close": "關閉",
  "recentFlow.loadFailed": "發貨資料載入失敗，請重試",
  "recentFlow.resultInvalid": "收貨結果異常，請重新載入核實",
  "recentFlow.success": "該批次確認收貨成功",
  "recentFlow.failed": "確認收貨失敗，請重試",
  "recentFlow.submitting": "提交中",
  "recentFlow.submitSettlement": "提交結單",
  "recentFlow.ordersLoading": "訂單載入中",
  "recentFlow.ordersEmpty": "暫無關聯訂單",
  "recentFlow.ordersFailed": "關聯訂單查詢失敗",
  "recentFlow.specFailed": "商品規格載入失敗",
  "recentFlow.splitFailed": "拆單失敗",
  "recentFlow.wholeSuccess": "整單設定成功",
  "recentFlow.splitSuccess": "拆單成功",
  "recentFlow.splitRetry": "拆單失敗，請稍後重試",
  "recentFlow.confirmWhole": "確認整單",
  "recentFlow.confirmSplit": "確認拆單",
  "recentFlow.wholeHint": "整單可調整各規格現價後填寫買家手機號碼提交",
  "recentFlow.splitHint": "填寫買家手機號碼，勾選規格後確認現價和拆單數量",
  "recentFlow.batchTitle": "第 {count} 批發貨",
  "recentFlow.specifications": "個規格",

  "bulkShipping.uploadFailed": "物流資訊上傳失敗，請稍後重試",
  "mobilePublish.itemTitle": "商品 {count}",
  "mobilePublish.copy": "複製",
  "mobilePublish.remove": "刪除",
  "mobilePublish.addItem": "新增商品",
  "mobileQuickOrder.waitForGoods": "請等待商品資訊載入完成後重試",
  "mobileQuickOrder.detailsFailed": "商品明細載入失敗，請重新整理後重試",
  "mobileQuickOrder.specificationsChanged": "商品規格已變更，請返回商品詳情重新選擇",

  ...sharedFlowUi,
  ...sharedUi,
  ...base,
  ...merged20261021,
  ...formDisplay,
  ...catalogDisplay,
  ...systemFeedback,
  ...business,
});

// 语言菜单使用各语言自称，不随当前界面语言更改。
export const languageNames = Object.freeze({
  "zh-CN": "简体中文",
  "zh-HK": "繁體中文（香港）",
  "en-US": "English",
});
